import { devicesEnCa } from '@mangovoice/devices-ui'
import { extensionsEnCa } from '@mangovoice/extensions-ui'
import { hotelsEnCa } from '@mangovoice/hotels-ui'
import { messagingEnCa } from '@mangovoice/messaging-ui'
import { musicOnHoldEnCa } from '@mangovoice/music-on-hold-ui'
import { pbxLocationsEnCa } from '@mangovoice/pbx-locations-ui'
import { pbxSettingsEnCa } from '@mangovoice/pbx-settings-ui'
import { phoneNumbersEnCa } from '@mangovoice/phone-numbers-ui'
import { soundClipsEnCa } from '@mangovoice/soundclips-ui'
import { systemSettingsEnCa } from '@mangovoice/system-settings-ui'
import { userGroupsEnCa } from '@mangovoice/user-groups-ui'
import { webhooksEnCa } from '@mangovoice/webhooks-ui'

import { en } from './en'
import { scheduleEn } from './schedule.en'

export const en_CA = {
  translation: {
    'Welcome to React': `Welcome to React and react-i18next`,
    yesterday: `Yesterday`,
    today: `Today`,
    day: `Day`,
    hour: `Hour`,
    week: `Week`,

    baseSettings: {
      profile: `Profile`,
      snippets: `Snippets`,
      phone: `Phone`,
      fax: `Fax`,
      notifications: `Notifications`,
      audio: `Audio`,
      updates: `Updates`,
      blockedNumbers: `Blocked Numbers`,
      integrations: `Integrations`,
      callCenter: `Call Centre`,
      experiments: `Experiments`,
      shortcutKeys: `Shortcut Keys`,
      collapse: `Collapse`,
      expand: `Expand`,
      new: `New`,
      admin: `Admin`,
      closeAdmin: `Close admin`,
      adminSections: `Admin sections`,
    },

    nav: {
      voicemail: `Voicemail`,
      calls: `Calls`,
      missedCalls: `Missed Calls`,
      text: `Text`,
      messaging: `Messaging`,
      fax: `Fax`,
      contacts: `Contacts`,
      settings: `Settings`,
      webPhone: `Web Phone`,
      reporting: `Reporting`,
      hotels: `Hotels`,
      switchboard: `Switchboard`,
      devices: `Devices`,
      extensions: `Extensions`,
      messagingGroups: `Messaging Groups`,
      soundClips: `Sound Clips`,
      musicOnHold: `Music on Hold`,
      phoneNumbers: `Phone Numbers`,
      locations: `Locations`,
      pbxSettings: `PBX Settings`,
      schedules: `Schedules`,
      integrations: `Integrations`,
      systemSettings: `System Settings`,
      users: `Users`,
      userGroups: `User Groups`,
      apiAccess: `API Access`,
      developers: `Developers`,
      mainNavigation: `Main navigation`,
      skipToMainContent: `Skip to main content`,
      callAnalytics: `Call Analytics`,
      status: `Status`,
    },

    users: {
      detail: {
        close: `Close user details`,
        loadingUser: `Loading user...`,
        pbxAssociations: {
          heading: `PBX Associations`,
          addToPbx: `Add to PBX`,
          filterPlaceholder: `Filter PBX associations...`,
          filterAriaLabel: `Filter PBX associations`,
          empty: `This user is not assigned to any PBX.`,
          noMatches: `No PBX associations match your search.`,
        },
      },
      generalInfo: {
        heading: `User Information`,
        copyCognitoKey: `Copy "Cognito Key"`,
        resetPassword: `Reset Password`,
        resetPasswordAria: `Reset password`,
        editUserInformation: `Edit user information`,
        deactivateUser: `Deactivate User`,
        activateUser: `Activate User`,
        username: `Username`,
        name: `Name`,
        role: `Role`,
        email: `Email`,
        lastLoggedIn: `Last Logged In`,
        created: `Created`,
        updated: `Updated`,
      },
      pbxAssociationCard: {
        editAria: `Edit association for {{pbxName}}`,
        removeAria: `Remove {{userName}} from {{pbxName}}`,
        assignedExtensions: `Assigned Extensions`,
        faxEmail: `Fax Email`,
        faxNumber: `Fax Number`,
        pin: `PIN`,
        faxTitle: `Fax Title`,
      },
      phonePermissions: {
        heading: `Phone Permissions`,
        loading: `Loading phone permissions...`,
        empty: `This user is not assigned to any phone permission groups.`,
        editAria: `Edit phone permissions for {{pbxName}}`,
        noGroupsAssigned: `No groups assigned.`,
      },
      pbxUserForm: {
        titleAdd: `Add to PBX`,
        titleEdit: `Edit PBX Association`,
        pbxLabel: `PBX`,
        pbxSearchPlaceholder: `Search PBX by name...`,
        pbxSearchAria: `Search PBX options by name`,
        pbxSearching: `Searching...`,
        pbxTypeToSearch: `Type to search PBX...`,
        pbxNoMatches: `No PBX matches that search.`,
        faxTitleLabel: `Fax Title`,
        faxTitlePlaceholder: `Fax title`,
        sendingFaxEmailLabel: `Sending Fax Email`,
        sendingFaxEmailPlaceholder: `Fax email address`,
        invalidEmail: `Enter a valid email address.`,
        sendingFaxNumberLabel: `Sending Fax Number`,
        faxNumberSearchPlaceholder: `Search fax numbers...`,
        faxNumberSelectPbxFirst: `Select a PBX first`,
        faxNumberSearchAria: `Search sending fax number options`,
        faxNumbersLoading: `Loading fax numbers...`,
        faxNumbersEmpty: `No fax numbers found for this PBX.`,
        pinLabel: `PIN`,
        pinPlaceholder: `4-digit PIN (1000-9999)`,
        userGroupsLabel: `User Groups`,
        userGroupsSelected_one: `{{count}} selected`,
        userGroupsSelected_other: `{{count}} selected`,
        cancel: `Cancel`,
        submitAdd: `Add to PBX`,
        submitEdit: `Save Changes`,
      },
      editPhonePermissions: {
        title: `Edit Phone Permissions: {{userName}}`,
        pbxLabel: `PBX: {{pbxName}}`,
        groups: `Groups`,
        noGroups: `No groups available for this PBX.`,
        required: `(required)`,
        selectedCount: `{{selected}} of {{total}} selected`,
        close: `Close`,
        submit: `Update Phone Permissions`,
      },
      formatAssignedAssets: {
        extension_one: `{{count}} assigned extension`,
        extension_other: `{{count}} assigned extensions`,
        device_one: `{{count}} assigned device`,
        device_other: `{{count}} assigned devices`,
        and: ` and `,
      },
      toast: {
        userCreated: {
          title: `User created`,
          description: `{{firstName}} {{lastName}} has been created.`,
        },
        userCreateError: {
          title: `Error creating user`,
        },
        userUpdated: {
          title: `User updated`,
        },
        userUpdateError: {
          title: `Error updating user`,
        },
        pbxAdded: {
          title: `User added to PBX`,
        },
        pbxUpdated: {
          title: `PBX association updated`,
        },
        error: `Error`,
        associationRemoved: {
          title: `Association removed`,
          description: `{{name}} has been removed from this PBX.`,
        },
        alreadyRemoved: {
          title: `Already removed`,
          description: `This user was not found in the PBX and may have already been removed.`,
        },
        removeFailed: `Failed to remove user from PBX.`,
        noPhonePermissionChanges: {
          title: `No phone permission changes`,
        },
        phonePermissionsUpdated: {
          title: `Phone permissions updated`,
        },
        updateGroupFailed: `Failed to update "{{name}}".`,
        phonePermissionsUpdateError: {
          title: `Failed to update phone permissions`,
          fallback: `Unable to update phone permissions.`,
        },
        defaultUserName: `User`,
      },
      removeDialog: {
        cannotTitle: `Cannot remove user from PBX`,
        thisUserCapitalized: `This user`,
        cannotBody: `<bold>{{userName}}</bold> has {{assets}} on this PBX. Re-assign or delete these assets before removing this user from the PBX.`,
        ok: `OK`,
        confirmTitle: `Remove user from PBX?`,
        thisUser: `this user`,
        confirmBody: `This will remove <bold>{{userName}}</bold> from the selected PBX.`,
        cancel: `Cancel`,
        remove: `Remove`,
      },
      list: {
        title: `Users`,
        searchPlaceholder: `Search by name, username, or email...`,
        searchAriaLabel: `Search users`,
        newUser: `New User`,
        newUserAriaLabel: `Create new user`,
        newUserDisabledAriaLabel: `Create new user (disabled)`,
        newUserPermissionTooltip: `You don't have permission to create users`,
        clickToCopy: `Click to copy`,
        copied: `Copied!`,
        loading: `Loading users...`,
        error: `Error`,
        emptyNoResultsTitle: `No results found`,
        emptyNoResultsDescription: `Try adjusting your search terms`,
        emptyNoUsersTitle: `No users yet`,
        emptyNoUsersDescription: `Get started by creating your first user`,
        removeFromPbxTitle: `Remove {{name}} from PBX`,
        removeFromPbxDescription: `If this user has any assigned devices or extensions, they will be reassigned to the selected user.`,
        reassignAndRemove: `Reassign & Remove`,
        cancel: `Cancel`,
        reassignAssetsTo: `Reassign assets to`,
        selectUserPlaceholder: `Select a user...`,
        searchingUsers: `Searching...`,
        noMatchingUsers: `No matching users`,
        searchUsersToReassign: `Search users to reassign assets to`,
        candidateLoadFailed: `Couldn't load users. Check your connection and try again.`,
        noOtherUsersOnPbx: `There are no other users on this PBX. Add another user before removing this one so their assets can be reassigned.`,
        defaultUserName: `User`,
        column: {
          name: `Name`,
          usernameOrEmail: `Username / Email`,
          role: `Role`,
          faxEmail: `Fax Email`,
          lastLogin: `Last Login`,
          lastUpdated: `Last Updated`,
          action: `Action`,
        },
        pagination: {
          resultsPerPage: `Results per page:`,
          previousPage: `Previous page`,
          nextPage: `Next page`,
          jumpToPage: `Jump to page {{page}}`,
          all: `All`,
          recordRange: `{{start}}—{{end}} of {{total}}`,
          recordRangeEmpty: `0 of 0`,
        },
      },
      resetPassword: {
        toast: {
          copiedTitle: `Reset link copied to clipboard`,
          copyFailedTitle: `Reset link generated but could not be copied`,
          manualCopyDescription: `Copy this reset URL manually: {{url}}`,
          missingUrlTitle: `Failed to generate reset link`,
          missingUrlDescription: `No reset URL was returned.`,
          requestFailedTitle: `Failed to reset password`,
          unexpectedErrorDescription: `An unexpected error occurred.`,
        },
      },
      create: {
        loadingForm: `Loading user form...`,
      },
      edit: {
        loadingDetails: `Loading user details...`,
        retryLoadingRoles: `Retry loading roles`,
      },
      form: {
        heading: {
          newUser: `New User`,
          editUser: `Edit User`,
        },
        section: {
          pbxAssignment: `PBX Assignment`,
        },
        field: {
          firstName: `First Name`,
          lastName: `Last Name`,
          username: `Username`,
          usernameHelper: `Required. 4 - 150 characters. Letters, numbers, periods, or dashes only. Note: Username cannot be changed after creation.`,
          email: `Email`,
          emailHelper: `Optional. Email cannot be changed once set.`,
          isStaff: `Is Mango Staff?`,
          staffHelperIntro: `This designation grants full access to the system with a few exceptions:`,
          staffHelperBullet1: `The user cannot assign the designation of Mango Superuser to users.`,
          staffHelperBullet2: `The user cannot modify Mango Superusers.`,
          staffHelperBullet3: `The user cannot modify servers, providers, or device manufacturers.`,
          isSuperuser: `Mango Superuser`,
          role: `Role`,
          rolePlaceholder: `------`,
          roleUnavailable: `Role options unavailable`,
          roleUnavailableHelper: `Role options are unavailable.`,
          roleWarning: `WARNING: This role applies to all PBXes the user belongs to. Carefully consider the implications before making changes.`,
          pbx: `PBX`,
          pbxSearchPlaceholder: `Search PBX by name...`,
          pbxSearchAriaLabel: `Search PBX options by name`,
          pin: `PIN`,
          pinPlaceholder: `4-digit PIN (1000-9999)`,
          faxTitle: `Fax Title`,
          faxTitlePlaceholder: `Fax title`,
          sendingFaxEmail: `Sending Fax Email`,
          sendingFaxEmailPlaceholder: `Fax email address`,
          sendingFaxNumber: `Sending Fax Number`,
          searchFaxNumbers: `Search fax numbers...`,
          selectPbxFirst: `Select a PBX first`,
          searchFaxNumbersAriaLabel: `Search sending fax number options`,
          userGroups: `User Groups`,
        },
        combobox: {
          searching: `Searching...`,
          typeToSearchPbx: `Type to search PBX...`,
          noPbxMatches: `No PBX matches that search.`,
          loadingFaxNumbers: `Loading fax numbers...`,
          noFaxNumbers: `No fax numbers found for this PBX.`,
        },
        userGroups: {
          placeholder: `Select user groups...`,
          searchPlaceholder: `Filter user groups...`,
          emptyLabel: `No user groups available for this PBX.`,
          noResultsLabel: `No user groups match your filter.`,
          summary_one: `{{count}} group selected`,
          summary_other: `{{count}} groups selected`,
        },
        button: {
          cancel: `Cancel`,
          saveAndCreateAnother: `Save & Create Another`,
          createUser: `Create User`,
          saveChanges: `Save Changes`,
        },
      },
    },

    switchboard: {
      list: {
        title: `Switchboard`,
        subtitle: `Create and manage call flows for your voice system`,
        newSwitchboard: `New Switchboard`,
        search: { placeholder: `Search by name...` },
        pagination: {
          resultsPerPage: `Results per page:`,
          previousPage: `Previous page`,
          nextPage: `Next page`,
          jumpToPage: `Jump to page {{page}}`,
          all: `All`,
        },
        grid: {
          errorTitle: `Error`,
          errorLoading: `Error loading switchboards:`,
          checkConsole: `Check console for details`,
          loading: `Loading switchboards...`,
        },
        empty: {
          noDataTitle: `No switchboards yet`,
          noDataDescription: `Get started by creating your first switchboard`,
          noResultsTitle: `No switchboards on this page`,
          noResultsDescription: `Try adjusting your page size or navigate to a different page`,
          noSearchResultsTitle: `No results found`,
          noSearchResultsDescription: `Try adjusting your search terms`,
        },
        card: {
          editAria: `Edit switchboard`,
          deleteAria: `Delete`,
          lastUpdated: `Last Updated`,
        },
        delete: {
          title: `Delete Switchboard`,
          body: `Are you sure you want to delete "{{displayName}}"? This action cannot be undone.`,
          cancel: `Cancel`,
          confirm: `Delete`,
        },
        deleteSuccessToast: `Switchboard deleted`,
        deleteFailedToast: `Failed to delete switchboard`,
        edit: {
          title: `Edit Switchboard`,
          nameLabel: `Name`,
          namePlaceholder: `e.g., Switchboard - 7074`,
          numberLabel: `Number`,
          numberPlaceholder: `e.g., 7074`,
          omitFromDirectoryLabel: `Omit From Directory`,
          omitNo: `No`,
          omitYes: `Yes`,
          cancel: `Cancel`,
          submit: `Update Switchboard`,
        },
      },
      edit: {
        loading: `Loading switchboard...`,
        notFound: {
          title: `Switchboard Not Found`,
          errorLoading: `Error loading switchboard: {{message}}`,
          description: `The switchboard with extension {{extensionDialPlan}} does not exist in the API.`,
          thisCouldMean: `This could mean:`,
          reasonDeleted: `The switchboard was deleted`,
          reasonNoData: `The extension exists but has no switchboard data`,
          reasonCorrupted: `The data is corrupted beyond recovery`,
          backToList: `← Back to Switchboards List`,
          unknownError: `Unknown error`,
        },
        save: {
          cannotSave: `Cannot save switchboard`,
          success: `Switchboard saved`,
          failed: `Failed to save switchboard`,
          requiredFieldError: `{{node}}: {{message}}`,
          unexpectedError: `An unexpected error occurred.`,
          targetMismatch: `The loaded switchboard does not match this page. Refresh before saving.`,
        },
        header: {
          backToList: `Back to switchboards`,
          defaultName: `Switchboard {{extensionDialPlan}}`,
          deleteSwitchboard: `Delete Switchboard`,
          save: `Save`,
          revertLocalChanges: `Revert local changes`,
          refreshSwitchboard: `Refresh Switchboard`,
        },
        oldFormat: {
          warning: `⚠️ Warning: Switchboard data is in old format`,
          description: `This switchboard was created with the old editor. The visual flow cannot be displayed until it's migrated to the new format.`,
        },
        routeConflict: {
          title: `Routing conflict`,
          description: `{{node}} → {{route}} has multiple destinations. Remove one before saving.`,
        },
        unconfiguredSchedule: {
          description: `A Schedule node in this call flow has no schedule selected. Pick a schedule before saving, or disconnect the node.`,
          descriptionPlural: `{{count}} Schedule nodes in this call flow have no schedule selected. Pick a schedule for each before saving, or disconnect them.`,
        },
        canvas: {
          emptyTitle: `No flow configured yet`,
          emptyDescription: `Click "Add Node" to start building your call flow`,
          validationToastTitle: `Warning!`,
          invalidConnection: `Invalid connection`,
        },
        unsavedChanges: {
          title: `Unsaved Changes`,
          body: `You have unsaved changes. Are you sure you want to leave?`,
          stay: `Stay`,
          save: `Save`,
          leave: `Leave`,
        },
        revert: {
          title: `Revert local changes?`,
          body: `This removes changes made in this browser session and reloads your last saved switchboard. It will not delete what is already saved.`,
          cancel: `Cancel`,
          confirm: `Revert Changes`,
          success: `Local changes reverted`,
          successDescription: `Restored your last saved switchboard.`,
        },
        versionConflict: {
          title: `New updates are available`,
          body: `Someone else saved changes to this switchboard. Keep your current edits, or load the latest saved version.`,
          keepWorking: `Keep My Changes`,
          loadLatest: `Load Latest Changes`,
        },
        refresh: {
          newerVersionTitle: `Switchboard refreshed`,
          newerVersionDescription: `A newer saved version was detected and loaded.`,
        },
        configPanel: {
          title: `Configure {{type}}`,
          notImplemented: `Configuration UI not yet implemented for this node type.`,
          cancel: `Cancel`,
          save: `Save`,
        },
      },
      nodeLabels: {
        start: `START`,
        transfer: `Transfer`,
        transfer_and_continue: `Transfer & Continue`,
        queue: `Queue`,
        auto_attendant: `Auto Attendant`,
        external_transfer: `External Transfer`,
        leave_voicemail: `Leave Voicemail`,
        schedule: `Schedule`,
        day_night: `Day/Night`,
        dial_by_name: `Dial by Name`,
        sound_clip: `Sound Clip`,
        wait: `Wait`,
        hang_up: `Hang Up`,
        jump_to_switchboard: `Jump To Switchboard`,
        conference_room: `Conference Room`,
        transfer_and_rollover: `Transfer & Rollover`,
        call_distribution: `Call Distribution`,
        change_caller_id: `Change Caller ID`,
        webhook: `Webhook`,
        interactive_webhook: `Interactive Webhook`,
        fax_detect: `Fax Detect`,
        sms_notification: `SMS Notification`,
        ai_agent_v1: `AI Agent`,
      },
      dialogs: {
        deleteNode: {
          title: `Delete Node`,
          body: `Are you sure you want to delete this node?`,
          bodyWithLabel: `Are you sure you want to delete "{{label}}"?`,
          warning: `This action cannot be undone. All connections to this node will also be removed.`,
          cancel: `Cancel`,
          confirm: `Delete`,
        },
        deleteEdge: {
          title: `Delete Connection`,
          body: `Are you sure you want to delete this connection?`,
          warning: `This action cannot be undone.`,
          cancel: `Cancel`,
          confirm: `Delete`,
        },
        deleteSwitchboard: {
          title: `Delete Switchboard`,
          body: `Are you sure you want to delete this switchboard?`,
          bodyWithName: `Are you sure you want to delete "{{name}}"?`,
          bodyWithId: `Are you sure you want to delete switchboard {{id}}?`,
          warning: `This action cannot be undone. All switchboard configuration and data will be permanently deleted.`,
          cancel: `Cancel`,
          confirm: `Delete`,
        },
      },
      core: {
        selectExtension: `Select extension...`,
        extensionLabel: `Extension`,
        selectSchedule: `Select schedule...`,
        scheduleLabel: `Schedule`,
        selectSoundClip: `Select sound clip...`,
        soundClipLabel: `Sound Clip`,
        selectSwitchboard: `Select switchboard...`,
        switchboardLabel: `Switchboard`,
        selectConferenceRoom: `Select conference room...`,
        conferenceRoomLabel: `Conference Room`,
        selectQueue: `Select queue...`,
        queueLabel: `Queue`,
        selectFax: `Select fax extension...`,
        faxLabel: `Fax Extension`,
        timeoutPlaceholder: `Timeout (seconds)`,
        timeoutIncrease: `Increase timeout`,
        timeoutDecrease: `Decrease timeout`,
        expand: `Expand`,
        minimize: `Minimize`,
        deleteNodeAria: `Delete node`,
        drop: `Drop`,
        drag: `Drag`,
        unnamed: `Unnamed`,
        voicemailOptions: {
          definedByExtension: `Defined by extension`,
          systemGenerated: `System Generated Greeting`,
          noGreeting: `No Greeting`,
          busy1: `Busy-1`,
          unavailable2: `Unavailable-2`,
          custom3: `Custom-3`,
          custom4: `Custom-4`,
          custom5: `Custom-5`,
          custom6: `Custom-6`,
          custom7: `Custom-7`,
          custom8: `Custom-8`,
          custom9: `Custom-9`,
        },
      },
      create: {
        nameRequired: `Name Required`,
        nameRequiredDescription: `Please enter a name for this switchboard.`,
        invalidNumber: `Invalid Number`,
        invalidNumberDescription: `Please enter a valid number.`,
        invalidNumberRange: `Number must be 0 or between 100 and 99999.`,
        pbxIdRequired: `PBX ID Required`,
        pbxIdRequiredDescription: `PBX ID is required to create a switchboard.`,
        createdSuccess: `Switchboard created`,
        createFailed: `Failed to create switchboard`,
        genericError: `An error occurred`,
        cannotAddSwitchboard: `Cannot add Switchboard '{{name}}'`,
        extensionAlreadyExists: `An extension with the number '{{number}}' already exists.`,
        dialogTitle: `New Switchboard`,
        close: `Close`,
        submitButton: `Create New Switchboard`,
      },
      nodes: {
        clickToConfigure: `Click to configure`,
        defaultLabel: `Node`,
        none: `None`,
        transfer: {
          extension: `Extension`,
          extensionHelp: `Extension to transfer the call to`,
          timeout: `Timeout (seconds)`,
          timeoutHelp: `Timeout in seconds before continuing to the next node`,
          onInvalid: `On Invalid`,
          onInvalidHelp: `Node to go to if extension is invalid`,
          onTimeout: `On Timeout`,
          onTimeoutHelp: `Node to go to if transfer times out`,
        },
        wait: {
          duration: `Duration (seconds)`,
          selectDuration: `Select duration...`,
          ringDuringWait: `Ring During Wait`,
        },
        hangUp: {
          noConfig: `This node terminates the call. No configuration needed.`,
          labelOptional: `Label`,
          labelPlaceholder: `Label for display`,
        },
        smsNotification: {
          missedCall: `Missed call`,
          custom: `Custom`,
          messageType: `Message Type`,
          message: `Message`,
          messagePlaceholder: `Missed call from {CALLER_ID}-{CALLER_NUMBER}`,
          tooltipNotesTitle: `Notes`,
          tooltipNotesAria: `SMS Message information`,
          tooltip: {
            intro: `Create your own message, embed Mango values. For example: An incoming call from 888-555-1212 with a Caller ID of John Doe would be entered as`,
            exampleTemplate: `Missed call from {CALLER_ID}-{CALLER_NUMBER}`,
            exampleResultLeadIn: `This would send a SMS message to the SMS Recipient that would appear like this`,
            exampleResult: `Missed call from John Doe-8885551212`,
            variablesHeading: `Variables`,
          },
          smsRecipient: `SMS Recipient`,
          smsRecipientInfo: `SMS Recipient information`,
          separateNumbersHint: `Separate numbers with a comma to send to multiple recipients`,
          or: `OR`,
          autoReplyToCaller: `Auto-reply to Caller`,
          sendFrom: `Send from`,
          selectSendFrom: `Select number...`,
          selectMessagingGroup: `Select messaging group...`,
          smsGroupLabel: `SMS Group:`,
          currentUnavailableNumber: `Current value (unavailable): {{value}}`,
          incomingCall: `Incoming call`,
          voicemail: `Voicemail`,
        },
        queue: {
          onEscape: `On Escape`,
          maxWait: `Max Wait:`,
        },
        transferAndRollover: {
          noAnswer: `No Answer`,
          busy: `Busy`,
        },
        common: {
          remove: `Remove`,
          addOption: `+ Add Option`,
          removeOption: `Remove option`,
          tooltip: {
            variablesHeading: `Variables`,
            callerIdDesc: `The caller id name of the person calling`,
            callerNumberDesc: `The number of the person calling`,
            numberDialedDesc: `The number that was dialed`,
            callUidDesc: `The unique id of the call that can be used to lookup the call record at a later time.`,
            dialedNumberNameDesc: `The name in mango of the number being called`,
            timeUtcDesc: `The time of the Call in UTC time zone`,
          },
        },
        schedule: {
          open: `Open`,
          closed: `Closed`,
          holiday: `Holiday`,
        },
        aiAgent: {
          agentId: `Agent ID`,
          agentIdPlaceholder: `Enter UUID (36 characters)`,
          onError: `On Error`,
          selectAgent: `Select agent...`,
          noAgents: `No agents configured`,
        },
        externalTransfer: {
          transferCompany: `Transfer Company`,
          noCompany: `--`,
          searchTransferCompany: `Search transfer companies...`,
          searchTransferCompanyAriaLabel: `Search transfer companies`,
          noTransferCompanyMatches: `No transfer companies match your search.`,
          number: `Number`,
          enterPhoneNumber: `Enter phone number`,
          phoneNumberExactDigitError: `Phone number must be exactly {{count}} digits`,
          phoneNumberDigitRangeError: `Phone number must contain {{min}} to {{max}} digits`,
          sipServer: `SIP Server`,
          enterSipServer: `Enter SIP server`,
          passThroughCallerId: `Pass Through Caller ID`,
          orUseThisCallerId: `Or Use This Caller ID`,
          selectCallerId: `Select caller ID...`,
          noPhoneNumbersAvailable: `No phone numbers available`,
          requireOneToConnect: `Require 1 to connect`,
        },
        callDistribution: {
          weight: `Weight`,
          weightWarning: `Warning! Total weight percentage should be 100. Now it's {{total}}`,
        },
        changeCallerId: {
          callerId: `Caller ID`,
          enterCallerId: `Enter caller ID`,
          addUpTo20Chars: `Add up to 20 characters to the front`,
          replaceCallerId: `Replace Caller ID`,
        },
        dialByName: {
          invalid: `Invalid`,
          lookupBy: `Lookup By`,
          extensionName: `Extension Name`,
          userName: `User Name`,
          sortOrder: `Sort Order`,
          firstName: `First Name`,
          lastName: `Last Name`,
          firstLastName: `First/Last Name`,
        },
        leaveVoicemail: {
          message: `Message`,
        },
        autoAttendant: {
          repeatTimes: `Repeat times`,
          allowExtensionDialing: `Allow Extension Dialing`,
          press: `Press`,
        },
        dayNight: {
          whenOpen: `When Open`,
          whenClosed: `When Closed`,
          open: `OPEN`,
          closed: `CLOSED`,
          pressToToggle: `(Press {{code}} to Toggle)`,
          basic: `Basic`,
          advanced: `Advanced`,
          toggleCode: `Toggle Code`,
          toastSuccess: `PBX DAY/NIGHT status updated successfully`,
          toastFailed: `Failed to update PBX day/night status`,
        },
        webhook: {
          tooltipTitle: `What to do?`,
          tooltipAria: `Webhook information`,
          notifyUrl: `Notify URL`,
          notifyUrlPlaceholder: `http://www.example.com/mango_notification.php`,
          tooltip: {
            intro: `Use this feature to send notifications to an external website or server`,
            exampleUsesHeading: `Example Uses:`,
            exampleUse1: `Screen pop notification`,
            exampleUse2: `Log calls`,
            exampleUse3: `Cause an action on another site`,
            exampleUse4: `Create leads`,
            exampleUrlHeading: `Example url`,
            curlyBracketsNote: `Curly brackets will be replaced by MangoVoice with actual data.`,
          },
        },
        interactiveWebhook: {
          tooltipAria: `Interactive Webhook information`,
          url: `URL`,
          urlPlaceholder: `http://www.example.com/webhook`,
          allowExtensionAsOption: `Allow extension as option`,
          option: `Option`,
          optionPlaceholder: `Option`,
          tooltip: {
            intro: `The Interactive webhooks allow real-time routing between Mango and your software.`,
            howItWorksHeading: `How it works:`,
            howItWorksBody: `Mango will make a GET request to the url defined. We will replace all {} variables with the actual data. You can use the parameters in the request to decide how to route the caller. This is done by sending back a response with the option you would like Mango to route the call to. This allows for realtime routing of the callers.`,
            exampleCasesHeading: `Example cases:`,
            exampleCase1: `Skills based routing`,
            exampleCase2: `Route customers back to the agent that handled the initial call`,
            exampleCase3: `Customize call route for returning callers.`,
            exampleRequestHeading: `Example request`,
            responseNote: `The option value in the response should correlate with options set on this object, you may also return an extension number.`,
            exampleResponseHeading: `Example Response`,
            exampleResponseBody: `{"status": "success", "option": "1"}`,
          },
        },
      },
    },

    schedule: scheduleEn,

    global: {
      close: `Close`,
      clearSearch: `Clear search`,
      tooltip: {
        copyLink: `Copy Link to Clipboard`,
        copyLinkAt: `Copy Link at {{timeStamp}}`,
        copyLinkText: `Copy Link`,
      },
      toast: {
        moveSuccess: `Voicemail moved successfully.`,
        moveError: `Failed to move voicemail.`,
        deleteSuccess: `Voicemail deleted successfully.`,
        deleteError: `Failed to delete voicemail.`,
        markUnreadSuccess: `Voicemail marked as unread.`,
        markUnreadError: `Failed to mark voicemail as unread.`,
        copyLinkSuccess: `Link Copied to Clipboard`,
        copySuccess: `Copied to clipboard`,
        copyError: `Unable to copy to clipboard`,
        extensionSwitched: `Extension switched to:`,
        pbxChanged: `PBX changed to:`,
        globalPhoneHotKeySuccess: `Hot key saved successfully`,
        globalPhoneHotKeyError: `Failed to save Hot Key`,
        globalPhoneHotKeyDisabled: `Disabled Hotkey.`,
        globalPhoneHotKeyEnabled: `Enabled Hotkey.`,
      },
      input: {
        defaultPlaceholder: `Type here`,
      },
      timeAgo: {
        justNow: `just now`,
        minutesAgo_one: `{{count}} min ago`,
        minutesAgo_other: `{{count}} mins ago`,
        hoursAgo_one: `{{count}} hour ago`,
        hoursAgo_other: `{{count}} hours ago`,
        daysAgo_one: `{{count}} day ago`,
        daysAgo_other: `{{count}} days ago`,
      },
      currency: {
        default: `{{value, currency}}`,
        withCode: `{{value, currency, currencyCode}}`,
      },
    },

    contactSearchInput: {
      placeholder: `Type a name or number`,
      invalidPhoneNumber: `Invalid phone number`,
      noNumber: `No number`,
    },

    newCallModal: {
      header: `New Call`,
      sendToWebPhone: `Send to Web Phone`,
      sendToDeskPhone: `Send to Desk Phone (Yealink)`,
      from: `From`,
      to: `To`,
      answerHandsetWhenItRings: `Answer your handset when it rings.`,
      attemptingToEstablishCallTo: `Attempting to establish call to {{phoneNumber}}...`,
      checkInternetConnection: `Please check your internet connection and try again.`,
      tryAgain: `Try Again`,
      establishingCallTo: `Establishing call to {{phoneNumber}}...`,
      failedToEstablishCallTo: `Failed to establish call to {{phoneNumber}}.`,
    },

    confirmBlockNumberModal: {
      title: `Block {{formattedPhoneNumber}}`,
      message: `Your PBX will no longer receive calls, texts or faxes from this number.`,
      confirmText: `Block Number`,
      cancelText: `Cancel`,
      toastBlockError: `There was a problem blocking {{formattedPhoneNumber}}, please try again.`,
      toastUnblockError: `There was a problem unblocking {{formattedPhoneNumber}}, please try again.`,
    },

    blockedNumbers: {
      addNumber: `Add Number`,
      headerSubtext: `All calls, texts, and faxes from the numbers listed below will be blocked.`,
      header: `Blocked Numbers`,
      clearButton: `Clear`,
      blockButton: `Block Number`,
      modalSubtext: `All calls, texts, and faxes from the numbers listed below will be blocked.`,
      noBlockedNumbers: `No blocked numbers found.`,
      unblockTooltip: `Unblock`,
      unblockNumberLabel: `Unblock {{formattedPhoneNumber}}`,
      numberUnblocked: `{{formattedPhoneNumber}} unblocked`,
      confirmUnblock: {
        title: `Unblock {{formattedPhoneNumber}}?`,
        message: `Your PBX will start receiving calls, texts and faxes from this number again.`,
        confirmText: `Unblock Number`,
        cancelText: `Cancel`,
      },
    },

    a11y: {
      messages: {
        senderContact: `Contact`,
        senderYou: `You`,
        senderTeam: `Your team`,
        messageMeta: `{{sender}}, {{time}}:`,
        newMessage: `New message from {{sender}}: {{body}}`,
        newMessages: `{{count}} new messages from {{sender}}`,
        attachment: `Attachment`,
        messageSent: `Message sent`,
        messageFailed: `Message failed to send. Retry available.`,
        openImage: `Open image {{name}}`,
        imageFrom: `Image from {{sender}}`,
        downloadFile: `Download {{name}}`,
      },
      composer: {
        label: `Message`,
        labelWithName: `Message {{name}}`,
      },
      toast: {
        close: `Close`,
      },
      nav: {
        notificationCount: `{{count}} new`,
      },
      filterGroup: {
        text: `Text filter`,
        voicemail: `Voicemail filter`,
        fax: `Fax filter`,
        snippets: `Snippet filter`,
      },
      recipient: {
        label: `Recipient name or number`,
        listLabel: `Suggested contacts`,
        results: `Contacts found: {{count}}`,
      },
    },

    messageInput: {
      statusMessage: {
        uploading: `Uploading...`,
        failedToUpload: `Failed to upload`,
      },
      attachMedia: `Attach Media`,
      addSnippet: `Add Snippet`,
      emojis: `Emojis 😃`,
      sendText: `Send Text`,
      inputPlaceholder: `Send a message here`,
      retry: `Retry`,
    },

    messagingPage: {
      emptyDetailViewMessage: `No Thread Selected`,
      errorToastMessage: `Invalid phone number`,
      textPlaceholder: {
        receivedFile: `Received File`,
        fileSent: `File Sent`,
      },
      subheadingText: `{{phoneNumber, phone}} from`,
    },

    newFaxModal: {
      header: `New Fax`,
      footer: {
        sendButtonText: `Send`,
      },
      loadingView: {
        sendingFax: `Sending fax...`,
      },
    },

    newFaxForm: {
      dropdownPlaceholder: `From...`,
      textAreaPlaceholder: `Enter cover page note`,
      switchText: {
        includeCoverPage: `Include Cover Page`,
        sendEmailConfirmation: `Send Email Confirmation`,
      },
      dropzonePlaceholder: `You can send up to 25mb Faxes`,
      tagInputPlaceholder: `Enter email address and press "Enter"`,
      tagInputGuideText: `You can submit up to {{maxEmailConfirmations}} email addresses`,
      coverPageNoteLabel: `Cover page note`,
      emailConfirmationsLabel: `Confirmation emails`,
      emailValueType: `email`,
    },

    sizeGauge: {
      totalSize: `Total Size: {{totalSize}} / {{sizeLimit}}`,
      exceededSize: `Exceeded by {{exceededSize}}`,
    },

    contentDefault: {
      placeholder: `Drag and drop file here, or click to browse`,
    },

    contentAcceptedMulti: {
      previewFile: `Preview {{fileName}}`,
      removeFile: `Remove {{fileName}}`,
      fileRemoved: `{{fileName}} removed`,
      moveUp: `Move {{fileName}} up`,
      moveDown: `Move {{fileName}} down`,
      fileMoved: `{{fileName}} moved to position {{position}} of {{total}}`,
      possibleDuplicate: `Possible duplicate`,
      tooLarge: `Too large`,
      possibleDuplicateAndTooLarge: `Possible duplicate, too large`,
      fileWithStatus: `{{file}} – {{status}}`,
    },

    newThreadModal: {
      header: {
        newThread: `New Thread`,
        noGroupFound: `No Group Found`,
      },
      sendButtonText: `Send`,
      contactText1: `This extension is not part of a messaging group.`,
      contactText2: `Head over to {{adminUrl}} and set up your messaging group, or contact your Mango Adminstrator`,
      contactLinkText: `What is a Messaging Group?`,
      placeholder: `Your message`,
    },

    deleteConfirmModal: {
      title: `Delete Voicemail?`,
      message: `This is permanent and cannot be undone.`,
      deleteButton: `Delete`,
      cancelButton: `Cancel`,
    },

    confirmModal: {
      defaultTitle: `Are you sure?`,
      confirmDeleteVoicemail: `Deleting this voicemail is permanent and cannot be undone.`,
      dontAskAgain: `Don't ask again`,
    },

    emptySearch: {
      shoot: `Shoot.`,
      nothingIsMatching: `Nothing is matching`,
      didYouSpellItRight: `Did you spell it right?`,
    },

    listItem: {
      unreadStatus: `Unread`,
      markedAsUnread: `Marked as unread`,
      markedAsRead: `Marked as read`,
    },

    messageThreadHeader: {
      rename: `Rename`,
      cancel: `Cancel`,
      threadNameLabel: `Thread name`,
    },

    dropZoneMappings: {
      fileToLarge: {
        title: `File Too Large`,
        description:
          "Looks like the file you're trying to upload is too large. Max file size is {{maxFileSize}}MB",
      },
      fileInvalidType: {
        link: `Learn more`,
        title: `Unsupported File Type`,
        faxDescription: `Looks like that file is an unsupported file type. {{link}} about supported file types`,
        description: `Looks like that file is an unsupported file type. Learn more about supported file types at {{urlLink}}`,
      },
      fileUploadFailed: {
        title: `Upload Failed`,
        description:
          "Looks like the file you're trying to upload failed to upload. Please try again.",
      },
      general: {
        title: `An unexpected error has occurred`,
        description: `An unexpected error has occurred, please try again.`,
      },
    },

    messageThreads: {
      emptyState: {
        title: `No Texts`,
        subtitle1: `You haven’t sent or received any texts yet`,
        subtitle2: `Send a text to get started`,
      },
      searchPlaceholder: `Search a name or number`,
      searchLabel: `Search messages`,
      allGroups: `All Groups`,
      new: `{{count}} New - see all`,
      markAllRead: `Mark All Read`,
      buttonText: `New Text`,
    },

    phoneOptions: {
      recent: `Recent`,
      missed: `Missed`,
    },

    chatOptions: {
      recent: `Recent`,
      unread: `Unread`,
    },

    snippetOptions: {
      pbx: `PBX`,
      personal: `Personal`,
    },

    chatMenu: {
      label: `Snippets`,
      settings: `Snippet settings`,
    },

    phoneMenu: {
      label: `Auto Answer`,
    },

    generalMenu: {
      label: `Send Feedback`,
    },

    experimentsMenu: {
      label: `Web Phone`,
    },

    developMenu: {
      notifications: `Notifications`,
      contacts: `Contacts`,
    },

    callState: {
      inboundAnswered: `Inbound Answered`,
      outboundAnswered: `Outbound Answered`,
      inboundMissedOrDeclined: `Inbound Missed or Declined`,
      outboundMissedOrDeclined: `Outbound Missed or Declined`,
    },

    voicemailState: {
      received: `Received a voicemail`,
      sent: `You left a voicemail`,
    },

    voicemailOptions: {
      recent: `Recent`,
      unread: `Unread`,
    },

    mangoPhoneTypes: {
      mobile: `Mobile`,
      work: `Work`,
      home: `Home`,
    },

    mangoContactTypes: {
      mango: `Mango Voice`,
    },

    markReadModal: {
      header: `Caution - Mark All Read`,
      message: `Marking all threads as read can NOT be undone`,
      confirmText: `Are you sure?`,
      confirmButton: `Confirm`,
    },

    faxViewList: {
      titleNoFaxes: `No Faxes`,
      titleNoMatchingFaxes: `No Matching Faxes`,
      subtitleTryRemovingFilters: `Try removing some filters`,
      subtitleNoFaxes: "Looks like you don't have any faxes.",
      buttonTextStartFax: `Start a Fax`,
      buttonTextStartFirstFax: `Start your first Fax`,
      searchPlaceholder: `Search a name or number`,
      searchLabel: `Search faxes`,
      status: {
        failed: `Failed`,
        pending: `Processing`,
        sent: `Sent`,
        received: `Received`,
        unknown: `Unknown`,
      },
    },

    pdfToolbar: {
      print: `Print`,
      download: `Download`,
      openInNewTab: `Open in New Tab`,
      firstPage: `First page`,
      previousPage: `Previous page`,
      nextPage: `Next page`,
      lastPage: `Last page`,
      rotate: `Rotate`,
      pageStatus: `Page {{pageNumber}} of {{pages}}`,
    },

    toolbar: {
      clearAll: `Clear All`,
      potentialDuplicates: `Potential Duplicates`,
    },

    call: {
      toast: {
        callDeclined: `Call from {{context}} declined`,
        callEnded: `Call with {{context}} ended`,
        callHeld: `Call with {{context}} held`,
        callParked: `{{callName}} transferred to {{parkingLotName}}`,
        callParkFailed: `Failed to park {{callName}} in {{parkingLotName}}`,
        callTargetUndialable: `Can't call {{target}} - check the number and try again`,
        callTransferred: `{{callName}} transferred to {{transferToName}}`,
        callTransferFailed: `Failed to transfer {{callName}} to {{transferToName}}`,
        callUnavailable: `Phone disconnected - unable to place call`,
      },
    },

    incomingCallModal: {
      newCallFrom: `New Call From`,
      rejectCall: `Reject Call`,
      acceptCall: `Accept Call`,
      endAndAccept: `End & Accept`,
      holdAndAccept: `Hold & Accept`,
      parkAndAccept: `Park & Accept`,
    },

    popupCallButtons: {
      accept: `Accept`,
      reject: `Reject`,
      endAndAccept: `End & Accept`,
      holdAndAccept: `Hold & Accept`,
      parkAndAccept: `Park & Accept`,
      switch: `Switch`,
      resume: `Resume`,
      end: `End`,
      tooltip: {
        accept: `Accept incoming call`,
        reject: `Reject incoming call`,
        endAndAccept: `End current call and accept incoming call`,
        holdAndAccept: `Put current call on hold and accept incoming call`,
        parkAndAccept: `Park current call and accept incoming call`,
        switch: `Switch to this call`,
        resume: `Resume this call`,
        end: `End this call`,
      },
    },

    callStatus: {
      deskPhone: `Desk Phone`,
      onHold: `On Hold`,
      ringing: `Ringing`,
      connected: `Connected`,
      connecting: `Connecting`,
      ready: `Ready`,
      dialing: `Dialing...`,
      reconnecting: `Reconnecting...`,
      onDeskPhone: `On desk phone`,
      connectedWithDuration: `Connected {{duration}}`,
      shortDial: `Dial`,
      shortRing: `Ring`,
      shortHold: `Hold`,
      shortConn: `Conn`,
      shortDesk: `Desk`,
    },

    callAnnouncements: {
      incomingCall: `Incoming call from {{name}}, {{number}}`,
      incomingCallNameOnly: `Incoming call from {{name}}`,
      connected: `Connected`,
      onHold: `On hold`,
      resumed: `Resumed`,
      muted: `Muted`,
      unmuted: `Unmuted`,
      callEnded: `Call ended`,
      answerFailed: `Couldn't answer the call`,
      holdFailed: `Couldn't put the call on hold`,
      resumeFailed: `Couldn't resume the call`,
    },

    callSoundIndicator: {
      onHold: `On Hold`,
      muted: `Muted`,
      reconnecting: `Reconnecting`,
    },

    popup: {
      tabs: {
        inboundCalls: `Inbound Calls`,
        messages: `Messages`,
      },
      emptyStates: {
        noCalls: {
          title: `No Calls found`,
          description: `There are currently no inbound calls available`,
        },
        noActiveCalls: `No active calls`,
        noMessages: {
          title: `No Messages found`,
          description: `There are currently no messages available`,
        },
      },
      footer: {
        poweredByMango: `Powered by Mango Voice`,
      },
      callButtons: {
        deskPhoneActive: `Call active on desk phone`,
        dismiss: `Dismiss`,
      },
      callItem: {
        unknownCaller: `Unknown Caller`,
        unknownNumber: `Unknown Number`,
        onHold: `On Hold`,
        pageIntercom: `Page/Intercom`,
        callDetails: `Call details`,
      },
      messageButtons: {
        dismiss: `Dismiss`,
        openMessage: `Open Message`,
      },
      personCard: {
        patientFile: `Patient File`,
        fullName: `Full Name`,
        dateOfBirth: `DOB`,
        patientNumber: `Patient #`,
        inboundNumber: `Inbound #`,
        extension: `Extension`,
        defaultLocation: `Default Location`,
        nextAppointment: `Next Appointment`,
        previousAppointment: `Previous Appointment`,
        insurance: `Insurance`,
        balance: `Balance`,
      },
      header: {
        expand: `Expand`,
        minimize: `Minimise`,
        dismiss: `Dismiss`,
        logoAlt: `Logo`,
      },
    },

    faxPage: {
      toast: {
        copyLinkSuccess: `Link Copied to Clipboard`,
        copyLinkError: `Failed to copy link to clipboard.`,
        sendSuccess: `Your fax has been added to the queue and will be sent shortly`,
        sendError: `There was a problem sending your fax. Please try again`,
        deleteSuccess: `Fax deleted successfully`,
        deleteError: `There was a problem deleting this fax. Please try again`,
        unexpectedError: `An unexpected error occurred`,
      },
      confirmDelete: {
        title: `Delete Fax`,
        message: `Are you sure you want to delete this fax?`,
        button: `Delete`,
        cancel: `Cancel`,
      },
      confirmResend: {
        title: `Resend Fax`,
        message: `Are you sure you want to resend this fax?`,
        button: `Resend`,
        cancel: `Cancel`,
      },
      emptyStateMessage: `No Fax Selected`,
      status: {
        queued: `Queued`,
        received: `Received`,
        sent: `Sent`,
      },
      direction: {
        to: `To`,
        from: `From`,
      },
      detailsHeader: {
        status: `{{statusPrefix}} on {{statusDate}} at {{statusTime}} {{directionText}}`,
      },
    },

    secureFaxPage: en.translation.secureFaxPage,

    voicemail: {
      emptyState: {
        title: `No Voicemails`,
        subtitle1:
          "Looks like you're answering all of your calls. Keep up the good work!",
        subtitle2:
          "If you think you're missing voicemails, please contact our support team.",
        buttonText: `Contact Support`,
      },
      searchPlaceholder: `Search for a caller name or number`,
      searchLabel: `Search voicemail`,
      emptyDetailViewMessage: `No Voicemail Selected`,

      mangoModal: {
        title: `Move`,
        headerText: `Move Voicemail`,
        cancelButtonText: `Cancel`,
        moveButtonText: `Move Voicemail`,
        selectVoicemailBoxText: `Select Voicemail Box...`,
        markAsUnreadText: `Mark as unread in the selected box`,
        destinationBoxText: `Destination Voicemail Box`,
        destinationBoxWarning:
          "This voicemail will become unavailable if you don't have access to the destination Voicemail Box.",
      },

      detailView: {
        headerSubheadingText: `From`,
        headerSubheadingToText: `To`,
        audioPlayerTitle: `Voicemail Audio`,
        transcriptionText: `Transcription`,
      },

      loadingText: `Voicemail`,
      transcriptionTitleText: `Transcription`,

      move: {
        error: `An error occurred while moving the voicemail.`,
        success: `Voicemail successfully moved`,
        successMarkAsUnread: `Voicemail successfully moved and marked as unread`,
        successMarkAsRead: `Voicemail successfully moved`,
      },

      filter: {
        all: `All`,
        unread: `Unread`,
        allInboxes: `All Inboxes`,
      },

      tooltip: {
        move: `Move`,
        delete: `Delete`,
        markAsUnread: `Mark as unread`,
        markAsRead: `Mark as read`,
        blockNumber: `Block number`,
        unblockNumber: `Unblock number`,
        copyLink: `Copy Link to Clipboard`,
        editContact: `Edit Contact`,
        newCall: `New Call`,
        newText: `New Text`,
        resendFax: `Resend Fax`,
        moveFax: `Move Fax`,
        newFax: `New Fax`,
        close: `Close`,
      },

      copyLinkError: `Failed to copy link to clipboard.`,
    },

    audioPlayer: {
      rewind10s: `Rewind 10s`,
      play: `Play`,
      pause: `Pause`,
      mute: `Mute`,
      unmute: `Unmute`,
      fastForward10s: `Fast Forward 10s`,
      jumpToAnswer: `Jump to Answer`,
      changePlaybackSpeed: `Change Playback Speed`,
      downloadAudio: `Download Audio`,
      seeKeyboardShortcuts: `See Keyboard Shortcuts`,
      mediaError: `There was a problem loading this audio file.`,
      noAudio: `No Recording Available`,
      playbackPosition: `Playback position`,
      playbackPositionValue: `{{position}} of {{duration}}`,
    },

    fax: {
      filter: {
        all: `All`,
        unread: `Unread`,
        allInboxes: `All Inboxes`,
        sent: `Sent`,
        received: `Received`,
      },
      tooltip: {
        pending: `This fax is processing and will be sent shortly`,
      },
    },

    pbxPrompt: {
      loggingIn: `Logging you in...`,
      loadingPbxs: `Loading PBXs...`,
      selectPbx: `Select your PBX`,
      noPbxMessage: `You are not currently a member of any phone system (PBX). To use this app, please contact the person in your office who manages the phone system to add you.`,
      noPbxErrorMessage: `If you believe this is an error, contact Mango Support for further assistance.`,
      callSupport: `Call support`,
      emailSupport: `Email support`,
      back: `Back`,
      errorTitle: `Whoops! Something went wrong.`,
      errorMessage: `Please try again or contact support.`,
    },

    pbxPicker: {
      searchPlaceholder: `Search PBXs...`,
      searchLabel: `Search PBXs`,
      current: `Current`,
      recent: `Recent`,
      allPbxs: `All PBXs`,
      searchResults: `Search Results`,
      noResults: `No PBXs found`,
      searchPrompt: `Search for a PBX by name`,
      switchPbx: `Switch PBX`,
      count: `{{count}} PBXs`,
      countFiltered: `{{count}} PBXs found`,
    },

    pbxHeaderSwitcher: {
      selectPbx: `Select PBX`,
      ariaLabel: `Switch PBX`,
    },

    loginPrompt: {
      loginFailedError: `Login failed. Please try again.`,
      invalidEmail: `Invalid email address!`,
      enterUsername: `Please enter username`,
      enterPassword: `Please enter a password`,
      invalidCredentials: `Invalid username or password, please check your credentials and try again.`,
      usernamePlaceholder: `email / username`,
      passwordPlaceholder: `password`,
      logIn: `Log In`,
      forgotPassword: `Forgot your password?`,
      openSupportForm: `Open support form`,
      backToLogin: `Back to login`,
      showPassword: `Show password`,
    },

    desktopAppBanner: {
      tryDesktopApp: `Try the {{appName}} desktop app for the best experience`,
      desktopAppName: `{{appName}} Desktop`,
      launchAppTooltip: `Launch desktop app if installed`,
      downloadAppTooltip: `Download desktop app`,
      launchApp: `Launch App`,
      download: `Download`,
      settings: `Settings`,
      dontAskAgain: `Don't Ask Again`,
      remindMeLater: `Remind me later`,
      alwaysOpenHint: `To always open links in the desktop app, change this in Settings.`,
      launchConfirmTitle: `Open in the desktop app`,
    },
    openApp: {
      title: `Opening your desktop app…`,
      subtitle: `We're launching the app now. If it doesn't open automatically, use the button below.`,
      closeHint: `You can close this tab once the app opens.`,
      openButton: `Open desktop app`,
      fallbackPrompt: `Don't have the desktop app installed?`,
      downloadButton: `Download the desktop app`,
    },

    openedInDesktop: {
      title: `We tried to open this page in the desktop app`,
      subtitle: `If the {{appName}} desktop app opened, you can close this tab.`,
      continueInBrowser: `Continue in browser`,
      tryAgain: `Try again`,
      stopOpeningInDesktop: `Stop opening links in the desktop app`,
      settingsHint: `To keep links in this browser, change <settingsLink>Desktop App in Settings</settingsLink>.`,
    },

    profileSettings: {
      myProfile: `My Profile`,
      editProfile: `Edit profile`,
      name: `Name`,
      username: `Username`,
      email: `Email`,
      openDesktopApp: `Open Desktop App`,
      launchDesktopApp: `Launch Desktop App`,
      callSupport: `Call Support`,
      emailSupport: `Email Support`,
      sendFeedback: `Send Feedback`,
      whatsNew: `What's New`,
      downloadApp: `Download App`,
      logOut: `Log Out`,
      needHelp: `Need Help?`,
      switchPbx: `Switch PBX`,
      pbxName: `PBX Name`,
      darkMode: `Dark Mode`,
      darkModeOptions: {
        light: `Light`,
        dark: `Dark`,
        system: `Use system settings`,
      },
      language: `Language`,
      desktopApp: {
        label: `Desktop App`,
        beta: `Beta`,
        modeLabel: `When I open a {{appName}} link in this browser`,
        modeHint: `This setting only applies to this browser.`,
        modes: {
          ask: `Ask me (show a banner)`,
          always: `Always open in the desktop app`,
          never: `Don't ask`,
        },
        testLaunch: {
          title: `Open links in the desktop app`,
          question: `We just tried to open the {{appName}} desktop app. Did it open?`,
          yes: `Yes, it opened`,
          no: `No, it didn't`,
          notOpened: `Links will keep opening in this browser. Install the {{appName}} desktop app, then try again.`,
          tryAgain: `Try again`,
          close: `Close`,
        },
      },
      switchPbxConfirmation: {
        title: `Change Your Current PBX`,
        message: `Calls, texts, faxes, and voicemails from {{pbxName}} will not be available on this application until you switch back.`,
        confirmText: `Ok`,
        cancelText: `Cancel`,
      },
      editMyProfile: {
        title: `Edit My Profile`,
        update: `Update Profile`,
        close: `Close`,
        firstName: `First Name`,
        lastName: `Last Name`,
        username: `Username`,
        email: `Email`,
        errRequiredFirstName: `Please make an entry for the First Name.`,
        errRequiredLastName: `Please make an entry for the Last Name.`,
        successProfile: `Profile successfully updated.`,
      },
    },

    pbxQuerySwitch: {
      confirm: {
        title: `Set your PBX?`,
        message: `Want to set your PBX to {{pbxName}}?`,
        confirmText: `Set PBX`,
        cancelText: `Cancel`,
      },
      warning: {
        invalid: {
          title: `Invalid PBX Link`,
          description: `The PBX link is invalid. Please try again from Admin.`,
        },
        inaccessible: {
          title: `Unable to Switch PBX`,
          description: `You don't have access to that PBX.`,
        },
      },
    },

    languageSelector: {
      title: `Language Preferences`,
      selectLanguage: `Select Language`,
      autoDetect: `Auto-detect (System Language)`,
      languages: {
        en: `English`,
        'en-US': `English (United States)`,
        'en-GB': `English (United Kingdom)`,
        'en-CA': `English (Canada)`,
        es: `Spanish`,
        'es-MX': `Spanish (Mexico)`,
        'es-US': `Spanish (United States)`,
        'fr-CA': `French (Canada)`,
        ko: `Korean`,
        ne: `Nepali`,
        te: `Telugu`,
      },
    },

    snippetsSettings: {
      confirmationModal: {
        title: `are you sure?`,
        message: `Deleting this Snippet is permanent and cannot be undone`,
        confirmText: `Delete`,
        cancelText: `Cancel`,
      },
      errorWithTimeout: `Something went wrong. Please try again later.`,
      headerText: `Snippets`,
      newButtonText: `New`,
      tooltipDelete: `Delete`,
      editSnippetLabel: `Edit snippet {{name}}`,
      deleteSnippetLabel: `Delete snippet {{name}}`,
      cancelEditing: `Cancel editing`,
      dismissError: `Dismiss error`,
      editSnippet: `Edit Snippet`,
      newSnippet: `New Snippet`,
      shortcut: `Shortcut`,
      inputPlaceholder: `GoodMorning`,
      shortcutGuideText: `One word, no spaces. e.g.: #good-morning or #TestResults`,
      visibility: `Visibility`,
      visibilityGuideText: `Personal = only you can access it, Company = everyone will access it`,
      editBodyInputPlaceholder: `Write a canned message here. You can add emails, web links, phone numbers...`,
      mangoButtonCancel: `Cancel`,
      mangoButtonSave: `Save`,
      loadingSnippets: `Loading Snippets...`,
      noSnippetsFound: `No Snippets Found`,
      body: `Body`,
      personal: `Personal`,
      filter: {
        all: `All`,
        unread: `Unread`,
        allInboxes: `All Inboxes`,
      },
    },

    phoneSettings: {
      incomingCalls: `Incoming Calls`,
      showInboundC2CCalls: `Show Inbound C2C Calls`,
      playRingtone: `Play Ringtone`,
      ringtone: `Ringtone`,
      respondWithBusyToSecondCall: `Respond with Busy to Second Call`,
      disabledInAgentMode: `Disabled when Agent Mode is enabled`,
      outgoingCalls: `Outgoing Calls`,
      defaultOutboundPhone: `Select default phone for outbound calls`,
      autoAnswer: `Auto Answer`,
      enableCallerIdSelection: `Enable Caller ID selection`,
      enableCallerIdSelectionDescription: `Allows you to choose the outgoing phone number when making calls.`,
      callerId: `Caller ID`,
      presence: `Presence`,
      presenceDescription: `The following sections will be displayed on your web phone giving you quick access to your most dialed extensions and numbers.`,
      parkingSpotsDisplayed: `Parking Spots Displayed (Limit 5)`,
      removeParkingSpot: `Remove Parking Spot`,
      addParkingSpot: `Add Parking Spot`,
      lineExtensionsDisplayed: `Line Extensions Displayed (Limit 10)`,
      removeExtension: `Remove Extension`,
      addExtension: `Add Extension`,
      speedDial: `Speed Dial (Limit {{maxSpeedDials}})`,
      editSpeedDial: `Edit Speed Dial`,
      removeSpeedDial: `Remove Speed Dial`,
      addSpeedDial: `Add Speed Dial`,
      clickToCall: `Click-to-Call`,
      sendToDeskPhone: `Send to Desk Phone (Yealink)`,
      useWebPhone: `Use Web Phone`,
    },

    phoneSettingItems: {
      selectExtension: `Select Extension`,
      yourExtension: `Your Extension`,
      activateWebPhone: `Activate Web Phone`,
      confirmationModal: {
        title: `No Line Extensions Available`,
        message1: `You do not have any line extensions assigned on this phone system ({{pbxName}}).`,
        message2: `To use the phone feature, please contact your system administrator to assign a line extension.`,
        confirmText: `Dismiss`,
        cancelText: `Cancel`,
      },
    },

    extensionSelector: {
      selectExtension: `Select A New Extension`,
      deactivateWebPhone: `Deactivate Web Phone`,
      none: `None`,
      confirmationModal: {
        title: `Unlink Device`,
        message: `This device will no longer send or receive calls from {{extensionName}}.`,
        confirmText: `Ok`,
        cancelText: `Cancel`,
      },
    },

    webPhone: {
      unknownCaller: `Unknown Caller`,
      selectParkingSpot: `Select a parking spot`,
      receivingCalls: `Receiving Calls`,
      doNotDisturb: {
        title: `Do Not Disturb`,
        until: `Until {{time}}`,
        indefinite: `Do not disturb`,
        for30Minutes: `Do not disturb for 30 minutes`,
        for1Hour: `Do not disturb for 1 hour`,
        for2Hours: `Do not disturb for 2 hours`,
        untilTomorrow: `Do not disturb until tomorrow`,
        turnOff: `Turn off do not disturb`,
        optionsLabel: `Do Not Disturb options`,
      },
      tooltip: {
        copied: `Copied!`,
        copyCallerId: `Copy Caller ID`,
        copyPhoneNumber: `Copy phone number`,
        endCall: `End Call`,
        muteCall: `Mute Call`,
        answerCall: `Answer Call`,
        switchToCall: `Switch to Call`,
        warmTransfer: `Warm Transfer`,
        holdCall: `Hold Call`,
        resumeCall: `Resume Call`,
        newCall: `New Call`,
        mergeCalls: `Merge Calls`,
        endConference: `End Conference`,
      },
      callError: {
        youAreDisconnected: `You are Disconnected`,
        connectionInterrupted: `Your connection was interrupted. Click here to retry the connection.`,
        reconnect: `Reconnect`,
        connecting: `Connecting…`,
        connectionFailed: `Phone connection failed. Please try again.`,
        retry: `Retry`,
        microphoneDisabled: `Microphone permissions are disabled!`,
        microphoneEnableText: `Enabling your microphone permission will allow use of the webphone.`,
        microphoneInUse: `Microphone is in use`,
        microphoneInUseText: `Your microphone is being used by another application. Close it (e.g. Zoom, Teams, or another tab) and try again.`,
        seeHereForHelp: `See here for help.`,
      },
      feedback: {
        reason: {
          soundDelayed: `Sound was delayed`,
          couldntHearOthers: `I couldn't hear others`,
          echo: `There was echo`,
          audioBreakingUp: `Audio was breaking up`,
          othersCouldntHearMe: `Others couldn't hear me`,
          otherAudioIssue: `Other audio issue`,
        },
        modal: {
          header: `What went wrong?`,
          dismiss: `Dismiss`,
          submit: `Submit Feedback`,
        },
        toast: {
          header: `Rate your call audio`,
          thanks: `Thanks!`,
          goodQuality: `Good call quality`,
          poorQuality: `Poor call quality`,
          dismiss: `Dismiss`,
        },
      },
    },

    faxSettings: {
      enableFaxCoverPage: `Enable Fax Cover Page`,
    },

    notificationSettings: {
      alertMessage:
        "You've blocked notifications. You'll need to go into your browser settings to switch this back on.",
      browserNotifications: `Browser Notifications`,
      playSoundForNewTexts: `Play Sound for New Texts`,
      testNotification: `Test notification`,
      volumeControl: `The volume of the notification is controlled by your computer`,
      help: `Help`,
      helpLinkText: `How do I turn on/off notifications`,
      onGoogleChrome: `on Google Chrome?`,
      callPop: {
        title: `Call and Text Notification Window`,
        description: `Try out our new notification window feature. This feature will show a small, separate window when you receive a call or text message. This allows you to see call and text information without interrupting your work!`,
        answerOnPatientInfoButtonClick: `Answer call when opening Patient Info`,
        showExampleButton: `Show example`,
        enableExampleHint: `Toggle the switch above to enable the example button`,
      },
      popupPosition: {
        title: `Popup Window Position`,
        topLeft: `Top Left`,
        topRight: `Top Right`,
        bottomLeft: `Bottom Left`,
        bottomRight: `Bottom Right`,
      },
    },

    callInProgressModal: {
      title: `Call in progress`,
      message: `Please end your current call before switching extensions`,
      dismiss: `Dismiss`,
    },

    sessionExpiredModal: {
      title: `Your session has expired`,
      message: `For your security, you have been signed out. Text message drafts are kept on this device. Sign in again to continue.`,
      signInAgain: `Sign in again`,
    },

    audioSettings: {
      selectSoundOutputSource: `Select sound output source - speakers`,
      selectInputSource: `Select input source - microphone`,
      toSelectAudioDevices: `To select audio devices, please grant microphone permissions`,
    },

    integrationsSettings: en.translation.integrationsSettings,

    updateSettings: {
      noExperimentsAvailable: `No experiments running at this time.`,
      channelSwitcher: {
        title: `Release Channel Switching`,
        description: `Choose which version of updates to receive. Production has the most stable features, while the other channels may provide a preview of new features. Switching channels requires restarting the application.`,
        devModeNote: `Development Mode: Channel switching is simulated and will reload the page instead of restarting the app.`,
        releaseChannel: `Release Channel`,
        selectChannel: `Select channel...`,
        switchChannel: `Switch Channel`,
        rollback: `Revert to {{channelName}}`,
        current: `Current: {{channelName}}`,
        switchTo: `Switch to:`,
        error: `Channel Unavailable`,
        validationError: `Unable to switch to {{channelName}}. The channel may not be available yet or there may be a network issue. Please try again later.`,
        switchFailed: `Failed to switch channel. Please try again.`,
        restartModal: {
          title: `Restart Required`,
          successMessage: `Successfully switched to <strong>{{channelName}}</strong> channel.`,
          warningMessage: `The application needs to update and then restart, in order to complete the channel switch. Any unsaved work will be lost.`,
          cancel: `Cancel`,
          restartNow: `Begin Switch`,
          switchingChannel: `Switching to {{channelName}}...`,
          checkingUpdates: `Checking for updates...`,
          downloadingUpdate: `Downloading update... {{progress}}%`,
          activatingChannel: `Activating channel...`,
          switching: `Switching...`,
        },
        highRiskWarning: {
          title: `Unstable Channel`,
          description: `This channel may contain experimental features, bugs, or incomplete functionality. Use at your own risk.`,
        },
        mediumRiskWarning: {
          title: `Pre-release Channel`,
          description: `This channel contains pre-release software that may have bugs or incomplete features.`,
        },
      },
      releaseNotifications: {
        title: `Release Notifications`,
        description: `Get an email when a new version of the app is released.`,
        descriptionWithChannel: `Get an email when a new version of the app is released on the {{channel}} channel.`,
        toggleLabel: `Email me about new releases`,
        recipient: `Notifications will be sent to the email address associated with your account.`,
        recipientWithEmail: `Notifications will be sent to {{email}}.`,
        resubscribeNote: `You previously unsubscribed. Turning this on will re-subscribe your email to release update emails.`,
        error: `Couldn't update your notification setting. Please try again.`,
        loadError: `Couldn't load your notification setting.`,
        retry: `Retry`,
        previewButton: `Preview email`,
        previewModalTitle: `Example release email`,
        previewModalNote: `A sample of what you'll receive. Actual content varies by release. Emails are sent in English.`,
        previewFrom: `From:`,
        previewSubject: `Subject:`,
        previewClose: `Close`,
        previewTipsTitle: `Make sure you get these emails`,
        previewSenderTip: `Emails come from:`,
        previewTipContacts: `Add that address to your contacts or address book.`,
        previewTipJunk: `If you don't see an email after a release, check your spam or junk folder and mark it "Not spam".`,
        previewTipSafelist: `On a work account, ask your IT admin to safelist the mangovoice.com domain.`,
      },
    },

    blockedNumberModal: {
      header: `Block Number`,
      description: `All calls, texts, and faxes from this number will be blocked.`,
      clearButton: `Clear`,
      blockButton: `Block Number`,
      inputPlaceholder: `Enter Phone Number`,
      inputLabel: `Phone number to block`,
      internationalHint: `For a number outside your country, start with + and the country code, like +44.`,
    },

    callCenterSettings: {
      enableAgentMode: `Enable Agent Mode`,
      customStatuses: `Custom Agent Statuses`,
      customStatusesDescription: `Set up custom statuses to track activities outside the call queue, like lunches, breaks, meetings, and more. Keep your team’s activity organized and visible.`,
      editStatus: `Edit Status`,
      deleteStatus: `Delete Status`,
      confirmationModal: {
        title: `Delete Custom Status`,
        text1: `Your custom status, `,
        text2: `, will be permanently deleted. Are you sure?`,
        confirmText: `Delete Status`,
        cancelText: `Cancel`,
      },
      newStatus: `New Status`,
      toast: {
        deleteStatusSuccess: `Status deleted successfully`,
      },
    },

    customStatusModal: {
      NameAddrHeader: `Add Custom Status`,
      editHeader: `Edit Custom Status`,
      inputLabel: `Status Name`,
      inputPlaceholder: `Name`,
      type: `Type`,
      typePlaceholder: `Select Type`,
      away: `Away`,
      online: `Online`,
      description: `Description`,
      descriptionPlaceholder: `What is this status used for?`,
      toast: {
        createSuccess: `Status created successfully`,
        editSuccess: `Status updated successfully`,
      },
      cancelButton: `Cancel`,
      saveButton: `Save`,
    },

    experimentsState: {
      queueDashboardEnabled: `Queue Dashboard`,
      queueDashboardDescription: `Enable the Queue Dashboard feature.`,
      missedCallsEnabled: `Missed Calls`,
      missedCallsDescription: `Enable the missed calls tracking feature.`,
      badge: {
        beta: `Beta`,
      },
      globalPhoneCapture: {
        title: `Global Phone Number Capture`,
        description: {
          intro: `Allows you to copy a phone number from any application on your computer, and then press a hotkey to populate that number into the Mango Voice dial pad.`,
          howToUse: `How to use this feature: First choose the hotkey combination below that you would like to use, then press the "Set Hotkey" button.`,
          afterSet: `Once your hot key is set, simply copy a phone number as you normally would in any other application (using Cmd/Ctrl+C, or the context menu), then press your chosen hot key to load that number into Mango Voice.`,
          note: `Note: Some hotkeys might be in use by other applications--Mango will try to detect any conflict and let you know.`,
        },
        activeSettingTitle: `Hotkey Status:`,
        activeAndSet: `Current Hotkey`,
        unsavedChanges: `Proposed Hotkey:`,
        configureTitle: `Configure Hotkey:`,
        keyLabel: `Key:`,
        status: {
          enabled: `Enabled`,
          disabled: `Disabled`,
        },
        button: {
          setHotkey: `Set Hotkey`,
          disableFeature: `Disable Hotkey`,
          enableFeature: `Enable Hotkey`,
          clearHotkey: `Clear Hotkey`,
        },
        notSet: `Not set`,
        toast: {
          hotkeyCleared: `Hotkey cleared`,
        },
      },
    },

    shortcutKeysHelp: {
      title: `Audio Player Keyboard Shortcuts`,
      keyboardKeys: {
        spaceBar: `Space Bar`,
        m: `M`,
        leftArrow: `←`,
        rightArrow: `→`,
        slash: `/`,
        shift: `Shift`,
      },
      playPause: `Play / Pause`,
      muteUnmute: `Mute / Unmute`,
      rewind10s: `Rewind 10s`,
      advance10s: `Advance 10s`,
      rewind3s: `Rewind 3s`,
      advance3s: `Advance 3s`,
      scopeNote: `Mute and skip shortcuts work while keyboard focus is in the audio player.`,
    },

    newParkingLotModal: {
      header: `Add Parking Spot`,
      parkingSpot: `Parking Spot`,
      label: `Label`,
      cancelButton: `Cancel`,
      saveButton: `Save`,
      parking1Label: `Parking 1`,
      parking2Label: `Parking 2`,
      parking3Label: `Parking 3`,
      parking4Label: `Parking 4`,
      parking5Label: `Parking 5`,
      parking6Label: `Parking 6`,
      parking7Label: `Parking 7`,
      parking8Label: `Parking 8`,
      parking9Label: `Parking 9`,
      parking10Label: `Parking 10`,
    },

    newExtensionSubscriptionModal: {
      header: `Add Extension Presence`,
      extension: `Extension`,
      cancelButton: `Cancel`,
      saveButton: `Save`,
    },

    dropdownSelect: {
      placeholder: `Select...`,
      noResultsFound: `No results found`,
      assignUserFirst: `Assign a user first`,
    },

    tooltips: {
      filter: `Filter`,
      dismiss: `Dismiss`,
      chartInformation: `Chart Information`,
    },

    form: {
      placeholder: {
        searchNameOrNumber: `Search a name or number`,
        selectStatus: `Select status`,
        selectUser: `Select user`,
        selectVirtualFax: `Select Virtual Fax...`,
        searchNumbers: `Search Numbers`,
        dateMonth: `MM`,
        dateDay: `DD`,
        dateYear: `YYYY`,
        timeHours: `HH`,
        timeMinutes: `MM`,
        timeMeridiem: `AM`,
      },
    },

    newSpeedDialModal: {
      addSpeedDial: `Add Speed Dial`,
      editSpeedDial: `Edit Speed Dial`,
      contactName: `Contact Name`,
      number: `Number`,
      cancelButton: `Cancel`,
      saveButton: `Save`,
    },

    actionsButton: {
      tooltipNewAction: `New Action`,
      newThread: `New Thread`,
      newCall: `New Call`,
      newFax: `New Fax`,
    },

    accountButton: {
      settings: `Settings`,
      connectionStatus: `App status`,
      switchPbx: `Switch PBX`,
      openApp: `Open App`,
      downloadApp: `Download App`,
      whatsNew: `What's New`,
      giveFeedback: `Give Feedback`,
      helpCenter: `Help Center`,
      logOut: `Log Out`,
      apiDocs: `API Docs`,
    },

    statusPanel: {
      title: `App status`,
      tabBasic: `Basic`,
      tabAdvanced: `Advanced`,
      tabListLabel: `App status views`,
      refresh: `Refresh`,
      refreshing: `Refreshing…`,
      refreshed: `Updated`,
      close: `Close`,
      copyDiagnostics: `Copy diagnostics`,
      copied: `Copied`,
      overallHealthy: `Healthy`,
      overallDegraded: `Degraded`,
      overallDown: `Down`,
      overallIdle: `Idle`,
      overallUnknown: `Unknown`,
      summaryGood: `Everything looks good.`,
      summaryProblem: `We found a problem.`,
      fixNetworkOffline: `Check your Wi-Fi or network cable, then try again.`,
      fixPhoneError: `Reload the page to reconnect the phone. If it keeps failing, contact support.`,
      fixRealtimeReconnecting: `Reconnecting automatically. If this persists, reload the page.`,
      fixRealtimeSuspended: `The app was paused. It should resume shortly — reload if it doesn't.`,
      fixRealtimeDisconnected: `Reload the page to restore messaging and call updates.`,
      rowInternet: `Internet`,
      rowPhoneService: `Phone service`,
      rowMessaging: `Messaging`,
      rowAppUpdates: `App updates`,
      stateUpdateReady: `Update ready`,
      stateCantInstallUpdates: `Can't install updates`,
      stateUpdateBlocked: `Update blocked`,
      stateUpdateReadyVersion: `Update ready ({{version}})`,
      stateUpdateDownloading: `Downloading update…`,
      stateUpdateDownloadingVersion: `Downloading update ({{version}})…`,
      stateUpdateCheckFailed: `Couldn't check for updates`,
      stateCheckingForUpdates: `Checking for updates…`,
      stateNotCheckedYet: `Not checked yet`,
      checkAgain: `Check again`,
      online: `Online`,
      offline: `Offline`,
      on: `On`,
      off: `Off`,
      // Health states
      stateOnline: `Online`,
      stateOffline: `Offline`,
      stateConnected: `Connected`,
      stateDisconnected: `Disconnected`,
      stateRegisteredReady: `Registered & ready`,
      stateConnecting: `Connecting…`,
      stateReconnecting: `Reconnecting`,
      stateSuspended: `Suspended`,
      stateRegistrationError: `Registration error`,
      // SIP enum labels
      regNotStarted: `Not started`,
      regRegistered: `Registered`,
      regUnregistered: `Unregistered`,
      regTerminated: `Terminated`,
      transportNotStarted: `Not started`,
      transportConnected: `Connected`,
      transportDisconnected: `Disconnected`,
      // Section titles + rows
      sectionSip: `SIP`,
      sectionMessaging: `Messaging / realtime`,
      sectionNetwork: `Network`,
      sectionTelephony: `Telephony`,
      sectionEnvironment: `Environment`,
      labelRegistration: `Registration`,
      labelTransport: `Transport`,
      labelLastError: `Last error`,
      labelWebSocket: `WebSocket`,
      labelLastHeartbeat: `Last heartbeat`,
      heartbeatAgo: `{{seconds}}s ago`,
      heartbeatStale: `{{seconds}}s ago (stale)`,
      heartbeatNone: `None yet`,
      labelReconnectAttempts: `Reconnect attempts`,
      labelBrowser: `Browser`,
      // Audio
      sectionAudio: `Audio`,
      labelMicPermission: `Microphone permission`,
      labelMicInput: `Microphone (input)`,
      labelSpeaker: `Speaker (output)`,
      deviceCount: `{{count}} found`,
      deviceDefault: `System default`,
      deviceNone: `None detected`,
      // Active call
      sectionCall: `Active call`,
      callNone: `No active call`,
      labelCallStatus: `Status`,
      labelCallDirection: `Direction`,
      labelCallSource: `Source`,
      labelCallHold: `On hold`,
      labelCallMuted: `Muted`,
      labelCallDuration: `Duration`,
      // App / environment additions
      labelLatestVersion: `Latest version`,
      labelUpToDate: `Up to date`,
      labelOutOfDate: `Update available`,
      labelChannel: `Channel`,
      labelPlatform: `Platform`,
      sectionSession: `Session`,
      labelSignedIn: `Signed in`,
      labelTokenExpiry: `Session expires`,
      tokenExpired: `Expired`,
      tokenValid: `Valid`,
      tokenNone: `No active session`,
      labelNotifications: `Notifications`,
      labelLocalStorage: `Local storage`,
      storageWritable: `Writable`,
      storageBlocked: `Blocked`,
      // Event log
      navChipDegraded: `App status: needs attention`,
      navChipDown: `App status: problem found`,
      navChipAria: `Problem detected. Open app status.`,
      sectionEvents: `Recent connection events`,
      noEvents: `No connection changes this session — the connection has been stable.`,
      eventOnline: `Network online`,
      eventOffline: `Network offline`,
      eventWsConnected: `Realtime connected`,
      eventWsReconnecting: `Realtime reconnecting`,
      eventWsSuspended: `Realtime suspended`,
      eventWsDisconnected: `Realtime disconnected`,
      labelPbx: `PBX`,
      labelPbxId: `PBX ID`,
      labelPbxUuid: `PBX UUID`,
      labelDoNotDisturb: `Do not disturb`,
      labelRespondBusy: `Respond busy to 2nd call`,
      labelAppVersion: `App version`,
      labelBuild: `Build`,
      labelCaptured: `Captured`,
      labelUserAgent: `User agent`,
      extensions: `Extensions`,
      noExtensions: `No extensions assigned.`,
      thisSession: `This session`,
    },

    contactsPage: {
      emptyDetailMessage: `No Contact Selected`,
      toast: {
        copyNumberSuccess: `Phone number copied to clipboard`,
        copyNumberError: `Unable to copy phone number`,
      },
    },

    contactsListView: {
      searchPlaceholder: `Search a name or number`,
      searchLabel: `Search contacts`,
      contactSourceContent: `All Contacts`,
      emptyNotice: {
        noContactsYet: `No Contacts here yet`,
        contactSupport: `Contact our support team to connect your patient contacts. Internal extensions will also appear here after you set them up at`,
        noContactsFound: `No Contacts Found`,
        noMatchingContacts: `We didn't find any contacts matching`,
      },
    },

    contactItems: {
      primary: `Primary`,
      actionButton: {
        copyNumber: `Copy Number`,
        callNumber: `Call Number`,
        messageNumber: `Message Number`,
        sendFax: `Send Fax`,
        callNumberLabel: `Call {{number}}`,
        messageNumberLabel: `Message {{number}}`,
        sendFaxLabel: `Send fax to {{number}}`,
        copyNumberLabel: `Copy {{number}}`,
        unblockNumberLabel: `Unblock {{number}}`,
      },
      emptyContactItem: `No phone numbers saved for this contact yet`,
      contactInformation: `Contact Information`,
      contactSource: `Contact Source:`,
      fromPms: `From {{pmsName}}`,
    },

    contactEventHistory: {
      recentActivity: `Recent Activity`,
      timespanText: `Last 14 Days`,
      historyLabel: {
        messaging: `Message Thread`,
        inboundCall: `Inbound Call`,
        outboundCall: `Outbound Call`,
        inboundFax: `Fax Received`,
        outboundFax: `Fax Sent`,
        voicemail: `Voicemail`,
      },
    },

    quickDialView: {
      tab: {
        favorites: `Favourites`,
        recentlyDialed: `Recently Dialed`,
      },
      groupName: {
        parkingSpots: `Parking Spots`,
        lineExtensions: `Line Extensions`,
        speedDial: `Speed Dial`,
      },
      phoneSettingsFor: `Phone settings: {{group}}`,
    },

    quickDialListItem: {
      empty: {
        parkingSpots: `To show parking spots here, adjust your web phone settings`,
        lineExtensions: `Add any line extension to see their availability here`,
        speedDial: `Store numbers you frequently call with speed dial`,
        recentlyDialedPrimary: `No Recently Dialed Numbers`,
        recentlyDialedSecondary: `After you make calls your recently dialed numbers will appear here.`,
      },
      button: {
        webPhoneSettings: `Web Phone Settings`,
        configurePresence: `Configure Presence`,
        configureSpeedDial: `Configure Speed Dial`,
      },
      parkingLot: {
        title: `Parking Lot`,
        subtitle: `Parking Lot`,
      },
      tooltip: {
        pickUpCall: `Pick up call`,
        startCall: `Start call`,
        parkCall: `Park call`,
        newCall: `Start a new call`,
        transferCall: `Transfer call`,
      },
      ariaLabel: {
        startCall: `Start call: {{name}}`,
        startCallWithStatus: `Start call: {{name}}, {{status}}`,
        newCall: `Start a new call: {{name}}`,
        newCallWithStatus: `Start a new call: {{name}}, {{status}}`,
        transferCall: `Transfer call: {{name}}`,
        transferCallWithStatus: `Transfer call: {{name}}, {{status}}`,
        pickUpCall: `Pick up call: {{name}}, {{status}}`,
        parkCall: `Park call: {{name}}, {{status}}`,
      },
      presence: {
        available: `Available`,
        busy: `Busy`,
        ringing: `Ringing`,
        occupied: `Occupied`,
        unknown: `Unknown`,
      },
    },

    callContactButton: {
      startCall: `Start Call`,
      startCallAriaLabel: `Start Call: {{name}}, {{number}}`,
      startCallNumberAriaLabel: `Start Call: {{number}}`,
      callNumber: `Call {{number}}`,
      callNumberWithLabel: `Call {{number}} - {{label}}`,
      otherNumbersAriaLabel: `Other numbers for {{name}}`,
    },

    phoneNumberInput: {
      placeholder: `Enter Number`,
      clearButton: `Clear`,
      inputLabel: `Phone number to call`,
    },

    phoneNumberMultiDropdown: {
      allNumbers: `All Numbers`,
    },

    phoneSearchInput: {
      placeholder: `Enter Name or Number`,
      clearButton: `Clear`,
      inputLabel: `Search by name or number`,
    },

    contactCardsList: {
      emptySearchText: `Enter a name or number above to start a search`,
    },

    outOfCallView: {
      tabButtonDialpad: `Dialpad`,
      tabButtonSearch: `Search`,
    },

    contactCardList: {
      searchResults: `Search Results`,
      noMatchingContacts: "We didn't find any contacts matching ",
    },

    callButton: {
      startCall: `Start Call`,
      endCall: `End Call`,
      disabled: `Disabled`,
      unknown: `Unknown`,
    },

    callControlButton: {
      endCall: `End Call`,
      splitConference: `Split Conference`,
      mergeCalls: `Merge Calls`,
      newCall: `New Call`,
      transfer: `Transfer`,
      park: `Park`,
      mute: `Mute`,
      keypad: `Keypad`,
      hold: `Hold`,
      audioSettings: `Audio Settings`,
    },

    onboardingView: {
      welcomeText: `Make Calls From Any Browser`,
      bodyText: `Make & receive calls, transfer or park with ease, manage multiple calls, add favorites & speed dials. Your communication, your way, from anywhere.`,
      buttonLabel: `Activate Phone`,
      confirmModal: {
        title: `No Line Extensions Available`,
        message1: `You do not have any line extensions assigned on this phone system {{pbxName}}.`,
        message2: `To use the phone feature, please contact your system administrator to assign a line extension.`,
        confirmText: `Dismiss`,
      },
    },

    callControl: {
      audioSettings: {
        title: `Audio Settings`,
        outputSource: `Output Source - Speakers`,
        inputSource: `Input Source - Microphone`,
      },
      parkCall: `Park Call`,
      transferCall: `Transfer Call`,
    },

    transferTarget: {
      buttonText: `Transfer Call`,
      buttonAriaLabel: `Transfer Call: {{name}}, {{number}}`,
    },

    transferHeader: {
      placeholder: `Enter Number`,
      ariaLabel: `Transfer`,
      inputLabel: `Transfer to number`,
    },

    parkTarget: {
      buttonText: `Park Call`,
      buttonAriaLabel: `Park Call: {{name}}`,
    },

    controlDrawer: {
      ariaLabel: `Close Drawer`,
    },

    dashboardsPage: {
      item: {
        agentStatus: `Agent Status`,
        eventLog: `Event Log`,
        inboundAnswerRate: `Inbound Answer Rate`,
        numberComparison: `Number Comparison`,
        extensionComparison: `Extension Comparison`,
        queueDashboard: `Queue Dashboard`,
      },
      group: {
        callCenter: `Call Centre`,
        callDashboards: `Call Dashboards`,
      },
    },

    queueDashboard: {
      emptyState: {
        title: `No information found`,
        description: `Select a queue from the list to view relevant data`,
      },
      filters: {
        title: `Queue`,
        subtitle: `See how your team's call activity compares`,
      },
      queueSelector: {
        placeholder: `Select from the list`,
        ariaLabel: `Select a call queue`,
      },
      metrics: {
        callersInQueue: `Callers In Queue`,
        maxWait: `Max Wait`,
        averageWait: `Average Wait`,
        maxAbandoned: `Max Abandoned`,
        averageAbandoned: `Average Abandoned`,
        dropRate: `Drop Rate`,
        answerRate: `Answer Rate`,
        sampleHistory: `Sample History`,
        sampleHistoryAriaLabel: `Select sample history time window`,
      },
      agentsPanel: {
        title: `Agent Queue`,
        activeAgents: `Active Agents`,
        inactiveAgents: `Inactive Agents`,
        searchPlaceholder: `Enter name or extension`,
        exportCsv: `Export CSV`,
        exportToast: {
          title: `Export`,
          description: `CSV export functionality coming soon.`,
        },
        loginFailed: {
          title: `Login Failed`,
          description: `Failed to log agent into the queue. Please try again.`,
        },
        logoutFailed: {
          title: `Logout Failed`,
          description: `Failed to log agent out of the queue. Please try again.`,
        },
      },
      callersTable: {
        title: `Inbound Queue`,
        callerNumber: `Caller #`,
        callerName: `Caller Name`,
        callTime: `Call / Wait time`,
        status: `Status`,
        emptyState: {
          title: `No information found`,
          description: `There is currently no information showing for the current Queue`,
        },
      },
      activeAgentsTable: {
        callerNumber: `Caller #`,
        agentName: `Agent Name`,
        ext: `Ext`,
        loggedIn: `Logged In`,
        talkTime: `Talk Time`,
        answered: `Answered`,
        missed: `Missed`,
        total: `Total`,
        status: `Status`,
        lastOffered: `Last Offered`,
        action: `Action`,
        emptyState: {
          title: `No Agents found`,
          description: `There is currently no information showing for the current Queue`,
        },
      },
      inactiveAgentsTable: {
        agent: `Agent`,
        ext: `Ext`,
        lastLoggedOut: `Last Logged out`,
        status: `Status`,
        action: `Action`,
        emptyState: {
          title: `No Agents found`,
          description: `There is currently no information showing for the current Queue`,
        },
      },
      agentRow: {
        changeStatus: `Change Status`,
        offline: `Offline`,
      },
      settings: {
        alertHoldTime: `Alert Hold Time`,
        alertHoldTimeAriaLabel: `Select hold alert threshold`,
        refreshEvery: `Refresh every`,
        refreshAriaLabel: `Select refresh interval`,
        seconds_one: `{{count}} second`,
        seconds_other: `{{count}} seconds`,
        minutes_one: `{{count}} min`,
        minutes_other: `{{count}} min`,
        hours_one: `{{count}} hr`,
        hours_other: `{{count}} hr`,
      },
      errorDisplay: {
        retrying_one: `Retrying in {{count}} second...`,
        retrying_other: `Retrying in {{count}} seconds...`,
        retryNow: `Retry Now`,
        retryingButton: `Retrying...`,
        persistentMessage: `Automatic refresh has been paused due to repeated failures.`,
      },
      status: {
        ready: `Ready`,
        onCall: `On Call`,
        ringing: `Ringing`,
        available: `Available`,
        break: `Break`,
        waiting: `Waiting`,
        answered: `Answered`,
        cancelled: `Cancelled`,
      },
    },

    inboundAnswerRate: {
      header: `Inbound Answer Rate`,
      subtitle: `Displays the percentage of inbound calls answered`,
      filters: {
        dateRange: `Date Range`,
        number: `Number`,
        maxPhoneNumbers: `(max {{max}})`,
      },
      counters: {
        answerRate: {
          title: `Answer Rate`,
          subtitle: `Percentage of calls answered`,
        },
        totalCalls: {
          title: `Total Calls`,
          subtitle: `Total inbound calls`,
        },
        answered: {
          title: `Answered Calls`,
          subtitle: `Total answered calls`,
        },
        missed: {
          title: `Missed Calls`,
          subtitle: `Total missed calls`,
        },
      },
      dashboard: {
        title: `Answer Rate Statistics`,
        errorText: `Error loading call data`,
        noDataText: `No call data available`,
        tableViewPlaceholder: `Table view coming soon`,
      },
      metrics: {
        answered: `Answered`,
        missed: `Missed`,
        answerRate: `Answer Rate`,
      },
      rechartTitle: `Calls Per {{groupByTitle}}`,
      viewToggle: {
        chart: `Chart`,
        table: `Table`,
      },
      table: {
        columns: {
          number: `Number`,
          answerRate: `Inbound Answer Rate`,
          answered: `Calls Answered`,
          missed: `Missed Calls`,
          total: `Total Calls`,
        },
        errorLoading: `Error loading phone number statistics`,
        noData: `No phone number data available`,
        unknown: `Unknown`,
      },
      invalidDateRange: `Invalid Date Range`,
      dateRangeTooLarge: `Date range is too large. Please select a range of 365 days or less.`,
      dateRangeAdjustPrompt: `Please adjust your date range and try again.`,
    },

    voicemailLineChart: {
      rechartTitle: `Voicemails Per {{groupByTitle}}`,
    },

    agentStatusFilters: {
      header: `Agent Status`,
      availability: `Availability`,
      status: `Status`,
      items: {
        online: `Online`,
        away: `Away`,
      },
    },

    agentStatusTable: {
      agent: `Agent`,
      extension: `Extension`,
      currentStatus: `Current Status`,
      timeInStatus: `Time In Status`,
      startedAt: `Started At`,
      actions: `Actions`,
      status: {
        offline: `Offline`,
        inQueue: `In Queue`,
      },
    },

    agentStatusActions: {
      tooltip: {
        changeStatus: `Change Status`,
      },
    },

    eventLog: {
      title: `Event Log`,
      filters: {
        allAgents: `All Agents`,
        searchAgents: `Search agents`,
      },
    },

    eventLogTable: {
      when: `When`,
      who: `Who`,
      status: `Status`,
      inQueue: `In Queue`,
      changedBy: `Changed By`,
      yes: `Yes`,
      no: `No`,
      system: `System`,
      unknown: `Unknown`,
      failedToLoad: `Failed to load more events.`,
      retry: `Retry`,
      noRecords: `No records found.`,
      noRecordsHint: `Try adjusting or clearing your filters to see more.`,
    },

    callDetailsOverviewTab: {
      missed: `Missed`,
      answered: `Answered`,
      textButton: `Voicemail Recorded`,
    },

    numberComparisonDashboard: {
      invalidDateRange: `Invalid Date Range`,
      dateRangeTooLarge: `Date range is too large. Please select a range of 365 days or less.`,
      dateRangeAdjustPrompt: `Please adjust your date range and try again.`,
      chartTitle: `Call Volume by Number`,
      showingCount: `Showing {{displayed}} of {{total}}`,
      counters: {
        totalCalls: {
          title: `Total Inbound Calls`,
          subtitle: `Total inbound calls across all numbers`,
        },
        numberCount: {
          title: `Total Numbers`,
          subtitle: `Total phone numbers tracked`,
        },
        averageCalls: {
          title: `Average per Number`,
          subtitle: `Average inbound calls per number`,
        },
        topNumber: {
          title: `Top Performer`,
        },
      },
      dashboard: {
        errorText: `Error loading number data`,
        noDataText: `No number data available`,
      },
      showMore: `Show More ({{remaining}} remaining)`,
      unknown: `Unknown`,
      notAvailable: `N/A`,
    },

    callDetailData: {
      missed: `Missed`,
      answered: `Answered`,
      inProgress: `In Progress`,
      failed: `Failed`,
      direction: {
        inbound: `Inbound`,
        outbound: `Outbound`,
        internal: `Internal`,
      },
    },

    callFilters: {
      buttonTitle: `Filter`,
      sections: {
        direction: `Direction`,
        outcome: `Outcome`,
        sentiment: `Sentiment`,
        status: `Status`,
        callTrait: `Call Trait`,
        duration: `Duration`,
        user: `User`,
        aiAgent: `AI Agent`,
      },
      direction: {
        inbound: `Inbound`,
        outbound: `Outbound`,
        internal: `Internal`,
      },
      outcome: {
        missed: `Missed`,
        answered: `Answered`,
      },
      sentiment: {
        office: `Office`,
        patient: `Patient`,
        negative: `Negative`,
        neutral: `Neutral`,
        positive: `Positive`,
      },
      status: {
        inProgress: `In Progress`,
        completed: `Completed`,
        failed: `Failed`,
        canceled: `Canceled`,
        busy: `Busy`,
      },
      callTrait: {
        voicemailRecorded: `Voicemail Recorded`,
        externallyTransferred: `Externally Transferred`,
      },
      duration: {
        longerThan: `Longer Than`,
        shorterThan: `Shorter Than`,
        tenSeconds: `10 seconds`,
        oneMinute: `1 minute`,
        fiveMinutes: `5 minutes`,
        tenMinutes: `10 minutes`,
      },
      user: {
        unknown: `Unknown User`,
      },
      aiAgent: {
        unknown: `Unknown AI Agent`,
      },
    },

    rechartsBarChart: {
      tooltip: {
        modalView: `Modal View`,
        answerRate: `Answer Rate:`,
        total: `Total:`,
      },
      noChartData: `No chart data available`,
      weekOf: `Week of {{date}}`,
    },

    reportingFilters: {
      dateRange: `Date Range`,
      number: `Number`,
      maxPhoneNumbers: `(max {{max}})`,
    },

    numberComparisonFilters: {
      numberComparison: `Number Comparison`,
      subtitle: `Compare inbound call volume across phone numbers`,
      dateRange: `Date Range`,
      number: `Number`,
      maxPhoneNumbers: `(max {{max}})`,
    },

    numberComparisonTable: {
      columns: {
        name: `Phone Number Name`,
        number: `Phone Number`,
        inboundCalls: `Inbound Calls`,
        avgDuration: `Avg Duration`,
      },
    },

    numberComparisonChart: {
      inboundCalls: `Inbound Calls`,
      avgDuration: `Avg Duration`,
    },

    extensionComparison: {
      retired: `Retired`,
    },

    extensionComparisonDashboard: {
      invalidDateRange: `Invalid Date Range`,
      dateRangeTooLarge: `Date range is too large. Please select a range of 365 days or less.`,
      dateRangeAdjustPrompt: `Please adjust your date range and try again.`,
      chartTitle: `Call Volume by Extension`,
      showingCount: `Showing {{displayed}} of {{total}}`,
      notAvailable: `N/A`,
      counters: {
        totalCalls: {
          title: `Total Calls`,
          subtitle: `Total calls across all extensions`,
        },
        averageCalls: {
          title: `Average per Extension`,
          subtitle: `Average calls per extension`,
        },
        averageMinutes: {
          title: `Average Minutes per Extension`,
          subtitle: `Average minutes per extension`,
        },
        topExtension: {
          title: `Top Performer`,
        },
      },
      dashboard: {
        errorText: `Error loading extension data`,
        noDataText: `No extension data available`,
      },
    },

    extensionComparisonFilters: {
      title: `Extension Comparison`,
      subtitle: `Compare call volume across extensions`,
      directionLabel: `Direction`,
      extensionsLabel: `Extensions`,
      direction: {
        all: `Inbound & Outbound`,
        inbound: `Inbound`,
        outbound: `Outbound`,
      },
    },

    extensionComparisonChart: {
      extensionLabel: `Extension {{ext}}`,
      totalCalls: `Total Calls`,
      totalMinutes: `Total Minutes`,
      avgDuration: `Average Duration`,
      showMore: `Show More ({{remaining}} remaining)`,
      totalCallsTitle: `Total Calls`,
      totalMinutesTitle: `Total Minutes`,
    },

    extensionComparisonTable: {
      columns: {
        extension: `Extension`,
        calls: `Calls`,
        percentCalls: `% Total`,
        minutes: `Minutes`,
        percentMinutes: `% Total`,
      },
    },

    extensionMultiDropdown: {
      allExtensions: `All Extensions`,
    },

    extensionPills: {
      extensionsSelected: `{{count}} extensions selected`,
    },

    dateDropdown: {
      today: `Today`,
      yesterday: `Yesterday`,
      last7Days: `Last 7 Days`,
      last14Days: `Last 14 Days`,
      last30Days: `Last 30 Days`,
      thisWeek: `This Week`,
      lastWeek: `Last Week`,
      thisMonth: `This Month`,
      lastMonth: `Last Month`,
      last60Days: `Last 60 Days`,
      last90Days: `Last 90 Days`,
      customRange: `Custom Range`,
    },

    dateTimeRange: {
      after: `After: {{date}}`,
      before: `Before: {{date}}`,
      selectDateRange: `Select Date Range`,
      buttonPlaceholder: `Select Date Range`,
    },

    dateTimeRangeModal: {
      after: `After `,
      before: `Before `,
      optional: `(optional)`,
      selectDateRange: `Select Date Range`,
      buttonPlaceholder: `Select Date Range`,
      clearButton: `Clear`,
      setDateRangeButton: `Set Date Range`,
      monthLabel: `{{label}} month`,
      dayLabel: `{{label}} day`,
      yearLabel: `{{label}} year`,
      hourLabel: `{{label}} hour`,
      minuteLabel: `{{label}} minute`,
      meridiemLabel: `{{label}} AM/PM`,
    },

    queueControlButton: {
      inQueue: `In Queue`,
      outOfQueue: `Out of Queue`,
      doNotDisturb: `Do Not Disturb`,
      online: `Online`,
      offline: `Offline`,
      joinQueue: `Join Queue`,
      leaveQueue: `Leave Queue`,
      goOffline: `Go Offline`,
    },

    queueStatusMenu: {
      online: `Online`,
      away: `Away`,
      goOffline: `Go Offline`,
      joinQueue: `In Queue`,
    },

    changelogModal: {
      whatsNewLabel: `What's New`,
      noResults: `No changelog available`,
      doneButton: `Done`,
      loadingData: `Loading changelog...`,
      latest: `(Latest)`,
      releasedLabel: `Released`,
    },

    queueToasts: {
      loggedInToQueue: `Logged in to queue`,
      loggedOutOfQueue: `Logged out of queue`,
      agentStatusUpdated: `Agent status updated`,
      unableToUpdateStatus: `Unable to update status`,
      queueUpdateErrorMessage: `Please make sure this User/Extension is added to a Call Queue in the Admin Portal or contact Support.`,
      genericUpdateErrorMessage: `Something went wrong while updating the status. Please try again or contact Support.`,
      ok: `OK`,
    },

    regionSelector: {
      settingsTitle: `Mango Data Region`,
      settingsDescription: `This indicates the region where your data is kept within the Mango ecosystem.`,
      selectRegion: `Select Region`,
      regionInfoTooltip: `Represents the Mango Data Region, not your location.`,
      regions: {
        unitedStates: `United States`,
        unitedKingdom: `United Kingdom`,
      },
    },

    announcementBanner: {
      infoLabel: `Info announcement: {{title}}`,
      warningLabel: `Warning announcement: {{title}}`,
      criticalLabel: `Critical announcement: {{title}}`,
      dismiss: `Dismiss announcement`,
      collapse: `Collapse announcement`,
      expand: `Expand announcement`,
    },
    bannerPager: {
      carousel: `Banners`,
      slide: `Banner {{current}} of {{total}}`,
      position: `{{current}}/{{total}}`,
      previous: `Previous banner`,
      next: `Next banner`,
      carouselRole: `carousel`,
      slideRole: `slide`,
    },

    appVersionBanner: {
      desktopUpdateAvailable: `Version {{version}} of {{appName}} is available!`,
      webUpdateAvailable: `A new version of the Mango Web App is available!`,
      restartAndUpdate: `Restart & Update`,
      updateNow: `Update Now`,
      whatsNew: `What's New`,
      remindLater: `Remind me later`,
      dismiss: `Dismiss`,
    },

    clockSkewBanner: {
      message: `Your device's clock is off by more than a few minutes. This can cause calls, messaging, and other features to behave unexpectedly. Please turn on automatic date & time syncing in your system settings.`,
    },

    updateBlockedBanner: {
      message: `The app couldn't finish updating. This is usually caused by antivirus or security software blocking the update. Ask your IT to allow the app to update, or download the latest version.`,
      downloadLatest: `Download latest version`,
    },

    updatePermissionBanner: {
      message: `The app can't install updates on this computer because of how it was installed. Follow our help article, or share it with your IT team.`,
      howToFix: `How to fix`,
      updateAnyway: `Update anyway`,
    },

    updateCheck: {
      checkForUpdates: `Check for Updates`,
      restartAndUpdate: `Restart & Update`,
      checking: `Checking for updates...`,
      upToDate: `App is up-to-date`,
      checkFailed: `Update check failed`,
      versionAvailable: `Version {{version}} is available`,
      downloading: `Downloading... {{percent}}%`,
      downloaded: `Version {{version}} downloaded`,
      errorOccurred: `An error occurred while checking for updates.`,
    },
    updateRequirement: {
      recommendedMessage: `A new version of {{appName}} is available. Update to get the latest fixes.`,
      recommendedMessageWithDate: `Update {{appName}} by {{date}} to continue to use it.`,
      requiredDuringCall: `This version of {{appName}} is no longer supported. When your call ends, you must update to continue.`,
      update: `Update`,
      later: `Later`,
      downloading: `Downloading {{percent}}%`,
      restartToUpdate: `Restart to update`,
      downloadInstaller: `Download installer`,
      requiredTitle: `Update required`,
      requiredMessage: `This version of {{appName}} ({{currentVersion}}) is no longer supported. Update to continue to use the app.`,
      callsNotice: `Until you update, this app cannot receive calls. Calls go to your other devices, ring groups, or voicemail.`,
      preparing: `Preparing the update...`,
      downloadingProgress: `Downloading the update: {{percent}}%`,
      progressLabel: `Update download progress`,
      manualInstallMessage: `The app cannot install the update automatically. Download and install the latest version.`,
      useWebApp: `Use the web app`,
      contactSupport: `Contact support`,
      alertTitle: `{{appName}} needs an update`,
      alertBody: `Calls go to other devices or voicemail until you update.`,
      copyDownloadLink: `Copy download link`,
      linkCopied: `Link copied`,
    },

    callDetails: {
      title: `Call Details`,
      callTimeline: `Call Timeline`,
      callFlow: `Call Flow`,
      started: `Started`,
      ended: `Ended`,
      answerTime: `Answer Time`,
      callDuration: `Call Duration`,
      callOn: `Call on`,
      statisticsNotAvailable: `Statistics are not available`,
      transcriptNotAvailable: `Transcript is not available`,
      noRecordingAvailable: `No recording available`,
      callSummary: `Call Summary`,
      callStatistics: `Call Statistics`,
      header: {
        copyLinkToCall: `Copy Link to Call`,
        copyLinkToCallAtTimestamp: `Copy Link to Call at Timestamp`,
        downloadAudio: `Download audio`,
        closePanel: `Close Panel`,
        expand: `Expand`,
        moreActions: `More Actions`,
      },
      sections: {
        sentimentByQuarter: {
          title: `Sentiment by Quarter`,
          tooltip: `This shows sentiment for the patient and office, reflecting the emotional tone of the conversation. Each quarter is classified as positive (green), neutral (gray), or negative (red).`,
          agentOverall: `Agent: {{score}} Overall`,
          customerOverall: `Customer: {{score}} Overall`,
          patient: `Patient`,
          office: `Office`,
        },
        officeTalkTime: {
          title: `Office Talk Time`,
          tooltip: `This pie chart shows a breakdown of the office's time spent talking versus listening during the call. Ideally, agents should spend more time listening than talking, aiming for a 50-60% talking and 40-50% listening split for effective customer interaction.`,
          talking: `Talking`,
          listening: `Listening`,
        },
        officeTalkSpeed: {
          title: `Office Talk Speed`,
          tooltip: `This shows the office's overall talk speed in words per minute (wpm). A normal range is 120-150 wpm, which is clear and easy to understand. Speeds below 100 wpm may feel too slow, while speeds above 160 wpm might be hard for patients to follow.`,
          wordsPerMinute: `Words Per Minute`,
        },
        interruptions: {
          title: `Interruptions`,
          tooltip: `This shows a breakdown of how many times the patient and office interrupted each other. It's useful for evaluating how smoothly the conversation went.`,
          total: `Total`,
          patient: `Patient`,
          office: `Office`,
        },
        holdAndPauseTime: {
          title: `Hold Time & Pauses`,
          tooltip: `This shows how much time the caller spent on hold or in silence, and the percentage of the total call. Longer-than-normal wait times are highlighted in red.`,
          percentageOfCall: `{{percentage}}% of call`,
        },
      },
      toast: {
        linkCopied: `Link Copied to Clipboard`,
        linkCopyFailed: `Failed to copy link to clipboard.`,
        voicemailTranscriptCopied: `Voicemail transcript copied to clipboard.`,
        voicemailTranscriptCopyFailed: `Unable to copy voicemail transcript.`,
        noVoicemailTranscript: `No voicemail transcript to copy.`,
        voicemailTranscriptCopyError: `Unable to copy the voicemail transcript. Please try again.`,
        summaryCopied: `Summary copied to clipboard.`,
        summaryCopyFailed: `Unable to copy the summary. Please try again.`,
        noSummary: `No summary to copy.`,
        feedbackThanks: `Thank you for your feedback!`,
        feedbackThumbsUpFailed: `Failed to report Thumbs Up action.`,
        feedbackThumbsDownFailed: `Failed to report Thumbs Down action.`,
      },
      voicemail: {
        title: `Voicemail`,
        loading: `Loading voicemail transcript...`,
        accessDenied: `This voicemail was left in an inbox you don't have access to. Contact your system administrator.`,
        deleted: `Voicemail has been deleted.`,
        notAvailable: `Voicemail not available.`,
        transcriptionNotAvailable: `Voicemail transcription not available.`,
      },
      summary: {
        title: `Summary`,
        processing: `Processing call transcription...`,
        notFound: `No Summary Found`,
        notAvailable: `No transcript summary available.`,
      },
      margoSummary: {
        title: `Margo Summary`,
        copy: `Copy Margo summary`,
        copied: `Margo summary copied`,
        copySuccess: `Margo summary copied to clipboard.`,
        copyFailure: `Unable to copy the Margo summary. Please try again.`,
      },
      tabs: {
        overview: `Overview`,
        transcripts: `Transcripts`,
        stats: `Stats`,
      },
      sentiment: {
        title: `Sentiment`,
        patient: `Patient`,
        office: `Office`,
        positive: `Positive`,
        negative: `Negative`,
        neutral: `Neutral`,
      },
      tooltip: {
        copyToClipboard: `Copy to clipboard`,
        goToVoicemail: `Go to voicemail`,
        accurate: `Accurate`,
        inaccurate: `Inaccurate`,
        copyLinkToSearch: `Copy Link to Search`,
        fullscreen: `Fullscreen`,
      },
    },

    calls: {
      searchLabel: `Search calls`,
      export: {
        button: `Export CSV`,
        starting: `Starting...`,
        preparing: `Preparing export...`,
        processing: `Exporting...`,
        completed: `Exported`,
        success: `CSV export started downloading`,
        successTruncated: `Export complete (results truncated to 1M rows)`,
        error: `Export failed`,
        errorTooMany: `Too many exports running. Please wait and try again.`,
        errorInvalid: `Invalid export parameters.`,
        errorNotFound: `Export job not found. The server may have restarted. Please retry.`,
        errorGeneric: `Failed to start export.`,
        errorStatusCheck: `Failed to check export status.`,
        toastProcessingTitle: `Export in progress`,
        toastProcessingDescription: `Your CSV is being prepared. The download will start automatically.`,
        unsupportedFiltersHeader: `CSV export doesn't support these filters:`,
        filterSearch: `Search`,
      },
      transcriptCell: {
        noTranscriptAvailable: `No transcript available.`,
        inProgress: `Transcript is currently being generated, please check back later.`,
        audioTooLong: `Transcript unavailable: the call audio was too long.`,
        viewTranscript: `View transcript`,
        noTranscript: `No transcript available`,
        transcriptInProgress: `Transcript in progress`,
        transcriptUnavailable: `Transcript unavailable`,
        openVoicemail: `Open voicemail`,
      },
      detail: {
        notFound: `Oops this record has either been deleted or does not exist. If you need help, please contact support.`,
        unknownNumber: `Unknown Number`,
        unknownSource: `Unknown`,
      },
    },

    missedCalls: {
      emptyState: `No missed calls`,
      emptyStateSubtitle: `All calls have been answered`,
      description: `Track and manage missed calls`,
      instructions: `Use filters and date ranges to find specific missed calls`,
      errorLoadingMissedCalls: `Error loading missed calls`,
      pleaseTryAgainLater: `Please try again later`,
      countLabel: `{{count}} Missed Calls`,
      refresh: `Refresh`,
      followUpStatus: {
        open: `Open`,
        returnedCallBack: `Returned - Call back`,
        returnedSMS: `Returned - SMS`,
        returnedVoicemail: `Returned - Voicemail`,
        returnedEmail: `Returned - Email`,
        returnedNoAnswer: `Returned - No answer`,
        noFollowUpRequired: `No follow up required`,
        assignUserFirst: `Assign a user first`,
      },
      filters: {
        sections: {
          type: `Type`,
          status: `Status`,
          user: `User`,
          phoneNumber: `Phone number`,
        },
        type: {
          voicemail: `Voicemail`,
          abandoned: `Abandoned`,
        },
        userFallback: `User {{id}}`,
      },
      assignedUser: {
        loading: `Loading...`,
        loadingShort: `Loading`,
        unassigned: `Unassigned`,
        userFallback: `User {{id}}`,
      },
      type: {
        voicemailAlt: `Voicemail`,
        abandonedAlt: `Abandoned`,
        abandonedTitle: `Abandoned`,
        abandonedDescription: `The call was not answered, and the customer did not leave a voicemail`,
      },
    },

    callsList: {
      noCallsFound: `No Calls Found`,
      tryDifferentFilters: `Try some different filters`,
    },

    callsTable: {
      label: `Calls`,
      openCallDetails: `View call details, {{time}} {{date}}`,
      columns: {
        dateTime: `Date & Time`,
        outcome: `Outcome`,
        to: `To`,
        from: `From`,
        toFrom: `To/From`,
        duration: `Duration`,
        transcript: `Transcript`,
      },
    },

    missedCallsTable: {
      columns: {
        dateTime: `Date & Time`,
        from: `From`,
        to: `To`,
        type: `Type`,
        followUpTime: `Follow up Time`,
        followUpStatus: `Follow up Status`,
        assignedTo: `Assigned to`,
        action: `Action`,
      },
    },

    contactInfoCard: {
      callTarget: {
        from: `From`,
        to: `To`,
      },
      tooltip: {
        call: `Call`,
        message: `Message`,
        sendFax: `Send Fax`,
        blockNumber: `Block Number`,
        unblockNumber: `Unblock Number`,
      },
    },

    contactCell: {
      menu: {
        callNumber: `Call Number`,
        copyNumber: `Copy Number`,
        messageNumber: `Message Number`,
        sendFax: `Send Fax`,
        blockNumber: `Block Number`,
        unblockNumber: `Unblock Number`,
        moreOptions: `More options`,
        moreOptionsFor: `More options for {{name}}, {{time}} {{date}}`,
      },
    },

    dashboards: {
      noDataAvailable: `No data available`,
      gettingPbx: `Getting PBX...`,
      noStatisticsAvailable: `No statistics available`,
      noGridData: `No grid data`,
      errorLoadingStatistics: `Error loading statistics`,
      errorLoadingCallData: `Error loading call data`,
      noCallDataAvailable: `No call data available`,
      errorLoadingVoicemailData: `Error loading voicemail data`,
      noVoicemailDataAvailable: `No voicemail data available`,
      csvExport: {
        buttonLabel: `Export CSV`,
        exported: `Exported`,
        success: `CSV exported`,
        failed: `CSV export failed`,
        headers: {
          inboundAnswerRate: {
            startDateTime: `Start Date/Time`,
            endDateTime: `End Date/Time`,
            answeredCalls: `Answered Calls`,
            missedCalls: `Missed Calls`,
            totalCalls: `Total Calls`,
            answerRatePercent: `Answer Rate %`,
          },
          numberComparison: {
            phoneNumber: `Phone Number`,
            displayNumber: `Display Number`,
            name: `Name`,
            inboundCalls: `Inbound Calls`,
            totalDurationSeconds: `Total Duration (seconds)`,
            averageDurationSeconds: `Average Duration (seconds)`,
          },
          extensionComparison: {
            extension: `Extension`,
            totalCalls: `Total Calls`,
            totalMinutes: `Total Minutes`,
            totalDurationSeconds: `Total Duration (seconds)`,
            averageDurationSeconds: `Average Duration (seconds)`,
          },
        },
      },
      unknown: `Unknown`,
      notAvailable: `N/A`,
    },

    aria: {
      backspace: `Backspace`,
      toggleColorMode: `Toggle colour mode`,
    },

    callAnalytics: {
      empty: {
        noTranscriptRecord: `Uh oh - there doesn't seem to be a transcript record for this call.`,
        noCallSelected: `No Call Selected`,
      },
      stats: {
        agentTalkTime: `Agent Talk Time`,
        talking: `Talking: {{duration}} ({{percent}}%)`,
        listening: `Listening: {{duration}} ({{percent}}%)`,
        agentTalkSpeed: `Agent Talk Speed`,
        wordsPerMinute: `{{count}} Words Per Minute (averaged)`,
        holdTimeAndPauses: `Hold Time and Pauses`,
        holdPercentOfCall: `{{duration}} ({{percent}}% of call)`,
        interruptionsTotal: `Interruptions: {{count}} total`,
        interruptionsAgent: `Agent: {{count}} ({{percent}}%)`,
        interruptionsCustomer: `Customer: {{count}} ({{percent}}%)`,
      },
      transcript: {
        office: `Office`,
        patient: `Patient`,
        silence: `Silence {{duration}}`,
        playFrom: `Play from {{time}}, {{speaker}}`,
        pauseFrom: `Pause from {{time}}, {{speaker}}`,
      },
    },

    filterModal: {
      header: `Filters`,
      apply: `Apply Filters`,
      clear: `Clear`,
      clearSection: `Clear {{title}}`,
      buttonTitle: `Filters`,
      tooltipOneApplied: `{{title}} ({{count}} filter applied)`,
      tooltipManyApplied: `{{title}} ({{count}} filters applied)`,
    },

    previewModal: {
      rotate: `Rotate`,
      imagePreview: `Image preview`,
    },

    pdfViewer: {
      loadError: `Unable to load this file`,
    },

    mangoPlusAds: {
      stayRelevant: `Stay relevant`,
      inTodaysWorld: `in today's world`,
      bodyHeading: `Who doesn't like texting?`,
      paragraph1: `In today's world, people love texting over phone calls. Choose to text your customers-save time and energy!`,
      paragraph2: `Texting is just one of the many Mango Plus perks. Talk to our Sales Team about a month trial before you buy.`,
      learnMore: `Learn More`,
    },

    outboundPhoneSearch: {
      placeholder: `Select Number`,
    },

    faxFilters: {
      directionTooltip: `Direction Filter`,
      allFaxes: `All Faxes`,
    },

    messagingThread: {
      dropFileToSend: `Drop file to send`,
    },

    resetPassword: {
      togglePasswordVisibility: `Toggle password visibility`,
    },

    resourceErrorBoundary: {
      defaultMessage: `An unexpected error occurred.`,
      notFoundFallback: `Oops this record has either been deleted or does not exist. If you need help, please contact support.`,
      takeMeBack: `Take me back`,
    },

    moveFaxModal: {
      toast: {
        errorMoving: `An error occurred while moving the fax.`,
        notMarkedUnread: `Fax was not marked as unread.`,
        moveFailed: `Failed to move the fax to the selected virtual fax.`,
        errorTitle: `Error Moving Fax`,
      },
      noAccessWarning: `If you don't have access to the selected Virtual Fax you won't be able to view this fax once it's been moved.`,
    },

    filePrinter: {
      printFailed: `Failed to print file.`,
    },

    router: {
      loadingContent: `Loading content...`,
    },

    resourceFailedToLoad: {
      permission: `You don't have permission to access this voicemail box`,
      deleted: `Voicemail deleted`,
      unavailable: `Voicemail unavailable`,
      contactAdmin: `To get access, contact your system administrator`,
    },

    tagInput: {
      commaSeparated: `Multiple values must be comma separated`,
      removeTag: `Remove {{value}}`,
      valueNotAdded: `This value could not be added`,
      valuesNotAdded: `These values could not be added`,
      invalidValue: `This value is not a valid {{valueType}}`,
      invalidValues: `These values are not a valid {{valueType}}`,
      limitReached: `Maximum of {{maxTags}} reached. Remove one to add another.`,
      errorAndLimit: `{{error}}. {{limit}}`,
    },

    unsavedChangesDialog: {
      title: `Unsaved changes`,
      body: `You have unsaved changes. Are you sure you want to leave this page? Your changes will be lost.`,
      stay: `Stay on page`,
      discard: `Discard changes`,
    },

    blockedNumber: {
      blockNumbers: `Block Numbers`,
    },

    notificationsBanner: {
      grantedPrefix: `Fantastic, notification preferences can be adjusted in`,
      settings: `settings`,
      prompt: `Mango works best with notifications to keep you up to date.`,
      enable: `Enable Notifications!`,
    },

    switchboardEdit: {
      invalidDialPlan: `Invalid extension dial plan`,
      invalidPbxId: `Invalid PBX ID`,
      loading: `Loading switchboard...`,
    },

    webPhoneExtras: {
      activeCall: `Active Call`,
      failedSearch: `Failed Search`,
      otherLabel: `other`,
      awayWithLabel: `Away - {{label}}`,
    },

    callDetailsExtras: {
      callInProgress: `Call in progress`,
      mayTakeMinutes: `This may take several minutes`,
    },

    contactCombinedCell: {
      fromPrefix: `F:`,
      toPrefix: `T:`,
    },

    responsivePage: {
      showList: `Show list`,
      hideList: `Hide list`,
    },

    loadingSpinner: {
      label: `Loading`,
    },

    messaging: messagingEnCa,
    phoneNumbers: phoneNumbersEnCa,
    pbxLocations: pbxLocationsEnCa,
    musicOnHold: musicOnHoldEnCa,
    hotels: hotelsEnCa,
    soundClips: soundClipsEnCa,
    ...systemSettingsEnCa,
    pbxSettings: pbxSettingsEnCa,
    devices: devicesEnCa,
    extensions: extensionsEnCa,
    userGroups: userGroupsEnCa,
    webhooks: webhooksEnCa,
  },
  support_phone_label: `Support Hotline: {{phoneNumber, phone}}`,
  user_profile_phone: `Your registered phone number is: {{userPhone, phone}}`,
} satisfies typeof en
